/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.14.3.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import moment from "moment";

export class ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Вход пользователя в ЦОК.
     * @param body Данные для входа.
     * @return Пользователь успешно авторизован.
     */
    login(body: LoginEcUser): Promise<AuthResult> {
        let url_ = this.baseUrl + "/api/v1/account/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<AuthResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("\u0423\u043a\u0430\u0437\u0430\u043d \u043d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u0444\u043e\u0440\u043c\u0430\u0442 \u0434\u0430\u043d\u043d\u044b\u0445.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ApiError.fromJS(resultData401);
            return throwException("\u0423\u043a\u0430\u0437\u0430\u043d \u043d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043b\u043e\u0433\u0438\u043d /\u043f\u0430\u0440\u043e\u043b\u044c.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthResult>(<any>null);
    }

    /**
     * Возвращает профиль авторизованного пользователя
     * @return Успешно.
     */
    profile(): Promise<EcUserDetails> {
        let url_ = this.baseUrl + "/api/v1/account/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfile(_response);
        });
    }

    protected processProfile(response: Response): Promise<EcUserDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EcUserDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EcUserDetails>(<any>null);
    }

    /**
     * Подтверждение учетной записи, проверка токена
     * @param body (optional) 
     * @return Success
     */
    checkAccountConfirmationToken(body: CheckAccountConfirmationToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/check-confirmation-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckAccountConfirmationToken(_response);
        });
    }

    protected processCheckAccountConfirmationToken(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ApiError.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Подтверждение учетной записи
     * @param body (optional) 
     * @return Success
     */
    confirmAccount(body: ConfirmAccount | undefined): Promise<AuthResult> {
        let url_ = this.baseUrl + "/api/v1/account/confirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfirmAccount(_response);
        });
    }

    protected processConfirmAccount(response: Response): Promise<AuthResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ApiError.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthResult>(<any>null);
    }

    /**
     * Возвращает состояние событий
     * @return Успешно.
     */
    getEventsState(): Promise<EventsStateHolder> {
        let url_ = this.baseUrl + "/api/v1/account/events-state";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEventsState(_response);
        });
    }

    protected processGetEventsState(response: Response): Promise<EventsStateHolder> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventsStateHolder.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventsStateHolder>(<any>null);
    }

    /**
     * @return Success
     */
    getCaptcha(): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/captcha";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCaptcha(_response);
        });
    }

    protected processGetCaptcha(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Подтверждение электронной почты
     * @param body (optional) 
     * @return Success
     */
    confirmEmailByToken(body: ConfirmEmailByToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/confirm-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfirmEmailByToken(_response);
        });
    }

    protected processConfirmEmailByToken(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ApiError.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Повторная отправка подтверждающего письма на почту
     * @param body (optional) 
     * @return Success
     */
    sendConfirmationEmailAgain(body: SendConfirmationEmailAgain | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/send-confirmation-email-again";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendConfirmationEmailAgain(_response);
        });
    }

    protected processSendConfirmationEmailAgain(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Смена пароля
     * @return Успешно.
     */
    changePassword(body: ChangePassword): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("\u0423\u043a\u0430\u0437\u0430\u043d \u043d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043f\u0430\u0440\u043e\u043b\u044c.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Сброс пароля пароля, отправка Email ссылкой
     * @return Success
     */
    sendEmailForResetPassword(body: SendEmailForResetPassword): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/send-email-for-reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendEmailForResetPassword(_response);
        });
    }

    protected processSendEmailForResetPassword(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Сброс пароля пароля, проверка токена
     * @param body (optional) 
     * @return Success
     */
    checkResetPasswordToken(body: CheckResetPasswordToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/check-reset-password-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckResetPasswordToken(_response);
        });
    }

    protected processCheckResetPasswordToken(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ApiError.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Сброс пароля пароля
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPassword | undefined): Promise<AuthResult> {
        let url_ = this.baseUrl + "/api/v1/account/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: Response): Promise<AuthResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ApiError.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthResult>(<any>null);
    }

    /**
     * @param searchField (optional) Поле, по которому осуществляется поиск
     * @param searchTerm (optional) Строка для поиска
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getApplicants(searchField: string | null | undefined, searchTerm: string | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<Applicants> {
        let url_ = this.baseUrl + "/api/v1/applicants?";
        if (searchField !== undefined && searchField !== null)
            url_ += "searchField=" + encodeURIComponent("" + searchField) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApplicants(_response);
        });
    }

    protected processGetApplicants(response: Response): Promise<Applicants> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Applicants.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Applicants>(<any>null);
    }

    /**
     * @return Success
     */
    getApplicant(applicantId: string): Promise<Applicant> {
        let url_ = this.baseUrl + "/api/v1/applicants/{applicantId}";
        if (applicantId === undefined || applicantId === null)
            throw new Error("The parameter 'applicantId' must be defined.");
        url_ = url_.replace("{applicantId}", encodeURIComponent("" + applicantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApplicant(_response);
        });
    }

    protected processGetApplicant(response: Response): Promise<Applicant> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Applicant.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Applicant>(<any>null);
    }

    /**
     * @return Success
     */
    getApplicantByPhone(phone: string): Promise<Applicant> {
        let url_ = this.baseUrl + "/api/v1/applicants/by-phone/{phone}";
        if (phone === undefined || phone === null)
            throw new Error("The parameter 'phone' must be defined.");
        url_ = url_.replace("{phone}", encodeURIComponent("" + phone));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApplicantByPhone(_response);
        });
    }

    protected processGetApplicantByPhone(response: Response): Promise<Applicant> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Applicant.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Applicant>(<any>null);
    }

    /**
     * @return Success
     */
    getIdentityDoc(applicantId: string): Promise<ApplicantIdentityDoc> {
        let url_ = this.baseUrl + "/api/v1/applicants/{applicantId}/identity-doc";
        if (applicantId === undefined || applicantId === null)
            throw new Error("The parameter 'applicantId' must be defined.");
        url_ = url_.replace("{applicantId}", encodeURIComponent("" + applicantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIdentityDoc(_response);
        });
    }

    protected processGetIdentityDoc(response: Response): Promise<ApplicantIdentityDoc> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicantIdentityDoc.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicantIdentityDoc>(<any>null);
    }

    /**
     * @return Success
     */
    getApplicantQualifications(applicantId: string): Promise<ApplicantQualification[]> {
        let url_ = this.baseUrl + "/api/v1/applicants/{applicantId}/qualifications";
        if (applicantId === undefined || applicantId === null)
            throw new Error("The parameter 'applicantId' must be defined.");
        url_ = url_.replace("{applicantId}", encodeURIComponent("" + applicantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApplicantQualifications(_response);
        });
    }

    protected processGetApplicantQualifications(response: Response): Promise<ApplicantQualification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicantQualification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicantQualification[]>(<any>null);
    }

    /**
     * @return Success
     */
    getApplicantQualificationDetails(applicantId: string, examApplicationId: string): Promise<ApplicantQualificationDetails> {
        let url_ = this.baseUrl + "/api/v1/applicants/{applicantId}/qualifications/{examApplicationId}";
        if (applicantId === undefined || applicantId === null)
            throw new Error("The parameter 'applicantId' must be defined.");
        url_ = url_.replace("{applicantId}", encodeURIComponent("" + applicantId));
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApplicantQualificationDetails(_response);
        });
    }

    protected processGetApplicantQualificationDetails(response: Response): Promise<ApplicantQualificationDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicantQualificationDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicantQualificationDetails>(<any>null);
    }

    /**
     * @param searchField (optional) Поле, по которому осуществляется поиск
     * @param searchTerm (optional) Строка для поиска
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getApplicantArchiveExams(applicantId: string, searchField: string | null | undefined, searchTerm: string | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<ApplicantExamList> {
        let url_ = this.baseUrl + "/api/v1/applicants/{applicantId}/archive-exams?";
        if (applicantId === undefined || applicantId === null)
            throw new Error("The parameter 'applicantId' must be defined.");
        url_ = url_.replace("{applicantId}", encodeURIComponent("" + applicantId));
        if (searchField !== undefined && searchField !== null)
            url_ += "searchField=" + encodeURIComponent("" + searchField) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApplicantArchiveExams(_response);
        });
    }

    protected processGetApplicantArchiveExams(response: Response): Promise<ApplicantExamList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicantExamList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicantExamList>(<any>null);
    }

    /**
     * @return Success
     */
    setApplicantTempPassword(applicantId: string, body: SetApplicantTempPassword): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/applicants/{applicantId}/set-temp-password";
        if (applicantId === undefined || applicantId === null)
            throw new Error("The parameter 'applicantId' must be defined.");
        url_ = url_.replace("{applicantId}", encodeURIComponent("" + applicantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetApplicantTempPassword(_response);
        });
    }

    protected processSetApplicantTempPassword(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Создаёт черновик заявки соискателя на экзамен
    Если соискатель с таким номером телефона уже есть в системе, создастся только заявка,
    иначе также будет создан профиль соискателя
     * @return Success
     */
    createExamApplicationDraft(body: CreateExamApplicationByQec): Promise<ExamApplicationDetails> {
        let url_ = this.baseUrl + "/api/v1/creation-exam-applications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateExamApplicationDraft(_response);
        });
    }

    protected processCreateExamApplicationDraft(response: Response): Promise<ExamApplicationDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamApplicationDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamApplicationDetails>(<any>null);
    }

    /**
     * @param searchField (optional) Поле, по которому осуществляется поиск
     * @param searchTerm (optional) Строка для поиска
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getExamApplicationDrafts(searchField: string | null | undefined, searchTerm: string | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<ExamApplicationList> {
        let url_ = this.baseUrl + "/api/v1/creation-exam-applications?";
        if (searchField !== undefined && searchField !== null)
            url_ += "searchField=" + encodeURIComponent("" + searchField) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExamApplicationDrafts(_response);
        });
    }

    protected processGetExamApplicationDrafts(response: Response): Promise<ExamApplicationList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamApplicationList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamApplicationList>(<any>null);
    }

    /**
     * @return Success
     */
    updateExamApplicationDraft(examApplicationId: string, body: UpdateExamApplicationByQec): Promise<ExamApplicationDetails> {
        let url_ = this.baseUrl + "/api/v1/creation-exam-applications/{examApplicationId}";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateExamApplicationDraft(_response);
        });
    }

    protected processUpdateExamApplicationDraft(response: Response): Promise<ExamApplicationDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamApplicationDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamApplicationDetails>(<any>null);
    }

    /**
     * @return Success
     */
    deleteExamApplicationDraft(examApplicationId: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/creation-exam-applications/{examApplicationId}";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteExamApplicationDraft(_response);
        });
    }

    protected processDeleteExamApplicationDraft(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getDocumentTemplateGroups(qualificationId: string): Promise<QualificationDocumentTemplateGroup[]> {
        let url_ = this.baseUrl + "/api/v1/creation-exam-applications/document-template-groups/{qualificationId}";
        if (qualificationId === undefined || qualificationId === null)
            throw new Error("The parameter 'qualificationId' must be defined.");
        url_ = url_.replace("{qualificationId}", encodeURIComponent("" + qualificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDocumentTemplateGroups(_response);
        });
    }

    protected processGetDocumentTemplateGroups(response: Response): Promise<QualificationDocumentTemplateGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QualificationDocumentTemplateGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QualificationDocumentTemplateGroup[]>(<any>null);
    }

    /**
     * @param contentType (optional) 
     * @param contentDisposition (optional) 
     * @param headers (optional) 
     * @param length (optional) 
     * @param name (optional) 
     * @param fileName (optional) 
     * @return Success
     */
    uploadExamApplicationDocument(examApplicationId: string, templateId: string, contentType: string | undefined, contentDisposition: string | undefined, headers: { [key: string]: string[]; } | undefined, length: number | undefined, name: string | undefined, fileName: string | undefined): Promise<ExamApplicationDetails> {
        let url_ = this.baseUrl + "/api/v1/creation-exam-applications/{examApplicationId}/documents/{templateId}";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType === null || contentType === undefined)
            throw new Error("The parameter 'contentType' cannot be null.");
        else
            content_.append("contentType", contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new Error("The parameter 'contentDisposition' cannot be null.");
        else
            content_.append("contentDisposition", contentDisposition.toString());
        if (headers === null || headers === undefined)
            throw new Error("The parameter 'headers' cannot be null.");
        else
            content_.append("headers", JSON.stringify(headers));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("length", length.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("name", name.toString());
        if (fileName === null || fileName === undefined)
            throw new Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("fileName", fileName.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadExamApplicationDocument(_response);
        });
    }

    protected processUploadExamApplicationDocument(response: Response): Promise<ExamApplicationDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamApplicationDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamApplicationDetails>(<any>null);
    }

    /**
     * @return Success
     */
    deleteExamApplicationDocument(examApplicationId: string, documentId: string): Promise<ExamApplicationDetails> {
        let url_ = this.baseUrl + "/api/v1/creation-exam-applications/{examApplicationId}/documents/{documentId}";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteExamApplicationDocument(_response);
        });
    }

    protected processDeleteExamApplicationDocument(response: Response): Promise<ExamApplicationDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamApplicationDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamApplicationDetails>(<any>null);
    }

    /**
     * @return Success
     */
    deleteExamApplicationDocumentSource(examApplicationId: string, documentId: string, sourceFileId: string): Promise<ExamApplicationDetails> {
        let url_ = this.baseUrl + "/api/v1/creation-exam-applications/{examApplicationId}/documents/{documentId}/source/{sourceFileId}";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (sourceFileId === undefined || sourceFileId === null)
            throw new Error("The parameter 'sourceFileId' must be defined.");
        url_ = url_.replace("{sourceFileId}", encodeURIComponent("" + sourceFileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteExamApplicationDocumentSource(_response);
        });
    }

    protected processDeleteExamApplicationDocumentSource(response: Response): Promise<ExamApplicationDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamApplicationDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamApplicationDetails>(<any>null);
    }

    /**
     * @return Success
     */
    submitExamApplication(examApplicationId: string): Promise<ExamApplicationDetails> {
        let url_ = this.baseUrl + "/api/v1/creation-exam-applications/{examApplicationId}/submit";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubmitExamApplication(_response);
        });
    }

    protected processSubmitExamApplication(response: Response): Promise<ExamApplicationDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamApplicationDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamApplicationDetails>(<any>null);
    }

    /**
     * @param examId (optional) 
     * @param searchField (optional) Поле, по которому осуществляется поиск
     * @param searchTerm (optional) Строка для поиска
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getExamApplications(examId: string | null | undefined, searchField: string | null | undefined, searchTerm: string | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<ExamApplicationList> {
        let url_ = this.baseUrl + "/api/v1/exam-applications?";
        if (examId !== undefined && examId !== null)
            url_ += "examId=" + encodeURIComponent("" + examId) + "&";
        if (searchField !== undefined && searchField !== null)
            url_ += "searchField=" + encodeURIComponent("" + searchField) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExamApplications(_response);
        });
    }

    protected processGetExamApplications(response: Response): Promise<ExamApplicationList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamApplicationList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamApplicationList>(<any>null);
    }

    /**
     * @param examId (optional) 
     * @param searchField (optional) Поле, по которому осуществляется поиск
     * @param searchTerm (optional) Строка для поиска
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getExamApplicationsPaymentRequired(examId: string | null | undefined, searchField: string | null | undefined, searchTerm: string | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<ExamApplicationList> {
        let url_ = this.baseUrl + "/api/v1/exam-applications/payment-required?";
        if (examId !== undefined && examId !== null)
            url_ += "examId=" + encodeURIComponent("" + examId) + "&";
        if (searchField !== undefined && searchField !== null)
            url_ += "searchField=" + encodeURIComponent("" + searchField) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExamApplicationsPaymentRequired(_response);
        });
    }

    protected processGetExamApplicationsPaymentRequired(response: Response): Promise<ExamApplicationList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamApplicationList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamApplicationList>(<any>null);
    }

    /**
     * @return Success
     */
    getExamApplication(examApplicationId: string): Promise<ExamApplicationDetails> {
        let url_ = this.baseUrl + "/api/v1/exam-applications/{examApplicationId}";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExamApplication(_response);
        });
    }

    protected processGetExamApplication(response: Response): Promise<ExamApplicationDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamApplicationDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamApplicationDetails>(<any>null);
    }

    /**
     * @return Success
     */
    sendCodeToApproveApplication(examApplicationId: string, body: SendCodeToApproveApplication): Promise<VerificationCodeSendingStatus> {
        let url_ = this.baseUrl + "/api/v1/exam-applications/{examApplicationId}/send-code-to-approve";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendCodeToApproveApplication(_response);
        });
    }

    protected processSendCodeToApproveApplication(response: Response): Promise<VerificationCodeSendingStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerificationCodeSendingStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerificationCodeSendingStatus>(<any>null);
    }

    /**
     * @return Success
     */
    admitToExam(examApplicationId: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/exam-applications/{examApplicationId}/admit-to-exam";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdmitToExam(_response);
        });
    }

    protected processAdmitToExam(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getExamSessionDetails(examApplicationId: string): Promise<ExamSessionDetails> {
        let url_ = this.baseUrl + "/api/v1/exam-applications/{examApplicationId}/exam-session";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExamSessionDetails(_response);
        });
    }

    protected processGetExamSessionDetails(response: Response): Promise<ExamSessionDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamSessionDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamSessionDetails>(<any>null);
    }

    /**
     * @return Success
     */
    generateOnlineExamRedirectionUrl(examApplicationId: string): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/exam-applications/{examApplicationId}/online-exam-redirection-url";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateOnlineExamRedirectionUrl(_response);
        });
    }

    protected processGenerateOnlineExamRedirectionUrl(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * Создание экзамена
     * @param body (optional) 
     * @return Success
     */
    createExam(body: CreateExamByEc | undefined): Promise<Exam> {
        let url_ = this.baseUrl + "/api/v1/exams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateExam(_response);
        });
    }

    protected processCreateExam(response: Response): Promise<Exam> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Exam.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Exam>(<any>null);
    }

    /**
     * @param qualificationIds (optional) 
     * @param examinationCenterIds (optional) 
     * @param filteredExamStatus (optional) 
     * @param from (optional) Дата экзамена, с
     * @param to (optional) Дата экзамена, по
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getExams(qualificationIds: string[] | null | undefined, examinationCenterIds: string[] | null | undefined, filteredExamStatus: FilteredExamStatus | undefined, from: moment.Moment | null | undefined, to: moment.Moment | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<ExamList> {
        let url_ = this.baseUrl + "/api/v1/exams?";
        if (qualificationIds !== undefined && qualificationIds !== null)
            qualificationIds && qualificationIds.forEach(item => { url_ += "qualificationIds=" + encodeURIComponent("" + item) + "&"; });
        if (examinationCenterIds !== undefined && examinationCenterIds !== null)
            examinationCenterIds && examinationCenterIds.forEach(item => { url_ += "examinationCenterIds=" + encodeURIComponent("" + item) + "&"; });
        if (filteredExamStatus === null)
            throw new Error("The parameter 'filteredExamStatus' cannot be null.");
        else if (filteredExamStatus !== undefined)
            url_ += "filteredExamStatus=" + encodeURIComponent("" + filteredExamStatus) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExams(_response);
        });
    }

    protected processGetExams(response: Response): Promise<ExamList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamList>(<any>null);
    }

    /**
     * Получение списка экзаменов с информацией о платежах
     * @param paid (optional) 
     * @param qualificationIds (optional) 
     * @param examinationCenterIds (optional) 
     * @param from (optional) Дата экзамена, с
     * @param to (optional) Дата экзамена, по
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getExamWithPaymentList(paid: boolean | null | undefined, qualificationIds: string[] | null | undefined, examinationCenterIds: string[] | null | undefined, from: moment.Moment | null | undefined, to: moment.Moment | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<ExamWithPaymentList> {
        let url_ = this.baseUrl + "/api/v1/exams/with-payment?";
        if (paid !== undefined && paid !== null)
            url_ += "paid=" + encodeURIComponent("" + paid) + "&";
        if (qualificationIds !== undefined && qualificationIds !== null)
            qualificationIds && qualificationIds.forEach(item => { url_ += "qualificationIds=" + encodeURIComponent("" + item) + "&"; });
        if (examinationCenterIds !== undefined && examinationCenterIds !== null)
            examinationCenterIds && examinationCenterIds.forEach(item => { url_ += "examinationCenterIds=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExamWithPaymentList(_response);
        });
    }

    protected processGetExamWithPaymentList(response: Response): Promise<ExamWithPaymentList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamWithPaymentList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamWithPaymentList>(<any>null);
    }

    /**
     * Получение информации по экзамену и платежам
     * @return Success
     */
    getExamWithPayment(examId: string): Promise<ExamWithPaymentDetails> {
        let url_ = this.baseUrl + "/api/v1/exams/with-payment/{examId}";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExamWithPayment(_response);
        });
    }

    protected processGetExamWithPayment(response: Response): Promise<ExamWithPaymentDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamWithPaymentDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamWithPaymentDetails>(<any>null);
    }

    /**
     * @param onlyEmployees Только сотрудники
     * @param qualificationId Квалификация, которой должна быть доступна для эксперта
     * @return Success
     */
    getAvailableExamExperts(onlyEmployees: boolean, qualificationId: string): Promise<AvailableExamExpert[]> {
        let url_ = this.baseUrl + "/api/v1/exams/available-experts?";
        if (onlyEmployees === undefined || onlyEmployees === null)
            throw new Error("The parameter 'onlyEmployees' must be defined and cannot be null.");
        else
            url_ += "onlyEmployees=" + encodeURIComponent("" + onlyEmployees) + "&";
        if (qualificationId === undefined || qualificationId === null)
            throw new Error("The parameter 'qualificationId' must be defined and cannot be null.");
        else
            url_ += "qualificationId=" + encodeURIComponent("" + qualificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAvailableExamExperts(_response);
        });
    }

    protected processGetAvailableExamExperts(response: Response): Promise<AvailableExamExpert[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailableExamExpert.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AvailableExamExpert[]>(<any>null);
    }

    /**
     * @return Success
     */
    getExam(examId: string): Promise<ExamDetails> {
        let url_ = this.baseUrl + "/api/v1/exams/{examId}";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExam(_response);
        });
    }

    protected processGetExam(response: Response): Promise<ExamDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamDetails>(<any>null);
    }

    /**
     * @return Success
     */
    assignExpertsToExam(examId: string, body: AssignExpertsToExam): Promise<Exam> {
        let url_ = this.baseUrl + "/api/v1/exams/{examId}/experts";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssignExpertsToExam(_response);
        });
    }

    protected processAssignExpertsToExam(response: Response): Promise<Exam> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Exam.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Exam>(<any>null);
    }

    /**
     * @param onlyEmployees (optional) Только сотрудники
     * @param qualificationId (optional) Квалификация, которой должен обладать эксперт
     * @param searchField (optional) Поле, по которому осуществляется поиск
     * @param searchTerm (optional) Строка для поиска
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getExperts(onlyEmployees: boolean | undefined, qualificationId: string | null | undefined, searchField: string | null | undefined, searchTerm: string | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<Experts> {
        let url_ = this.baseUrl + "/api/v1/experts?";
        if (onlyEmployees === null)
            throw new Error("The parameter 'onlyEmployees' cannot be null.");
        else if (onlyEmployees !== undefined)
            url_ += "onlyEmployees=" + encodeURIComponent("" + onlyEmployees) + "&";
        if (qualificationId !== undefined && qualificationId !== null)
            url_ += "qualificationId=" + encodeURIComponent("" + qualificationId) + "&";
        if (searchField !== undefined && searchField !== null)
            url_ += "searchField=" + encodeURIComponent("" + searchField) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExperts(_response);
        });
    }

    protected processGetExperts(response: Response): Promise<Experts> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Experts.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Experts>(<any>null);
    }

    /**
     * @param expertIds Список идентификаторов экспертов
     * @return Success
     */
    getExpertsByIds(expertIds: string[]): Promise<Expert[]> {
        let url_ = this.baseUrl + "/api/v1/experts/by-ids?";
        if (expertIds === undefined || expertIds === null)
            throw new Error("The parameter 'expertIds' must be defined and cannot be null.");
        else
            expertIds && expertIds.forEach(item => { url_ += "expertIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExpertsByIds(_response);
        });
    }

    protected processGetExpertsByIds(response: Response): Promise<Expert[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Expert.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Expert[]>(<any>null);
    }

    /**
     * @return Success
     */
    getExpert(expertId: string): Promise<Expert> {
        let url_ = this.baseUrl + "/api/v1/experts/{expertId}";
        if (expertId === undefined || expertId === null)
            throw new Error("The parameter 'expertId' must be defined.");
        url_ = url_.replace("{expertId}", encodeURIComponent("" + expertId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExpert(_response);
        });
    }

    protected processGetExpert(response: Response): Promise<Expert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Expert.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Expert>(<any>null);
    }

    /**
     * @return Success
     */
    getExpertCertificates(expertId: string): Promise<ExpertCertificate[]> {
        let url_ = this.baseUrl + "/api/v1/experts/{expertId}/certificates";
        if (expertId === undefined || expertId === null)
            throw new Error("The parameter 'expertId' must be defined.");
        url_ = url_.replace("{expertId}", encodeURIComponent("" + expertId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExpertCertificates(_response);
        });
    }

    protected processGetExpertCertificates(response: Response): Promise<ExpertCertificate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExpertCertificate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpertCertificate[]>(<any>null);
    }

    /**
     * @return Success
     */
    getExpertQualifications(expertId: string): Promise<ApplicantQualification[]> {
        let url_ = this.baseUrl + "/api/v1/experts/{expertId}/qualifications";
        if (expertId === undefined || expertId === null)
            throw new Error("The parameter 'expertId' must be defined.");
        url_ = url_.replace("{expertId}", encodeURIComponent("" + expertId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExpertQualifications(_response);
        });
    }

    protected processGetExpertQualifications(response: Response): Promise<ApplicantQualification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicantQualification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicantQualification[]>(<any>null);
    }

    /**
     * @param qualificationIds (optional) 
     * @param examinationCenterIds (optional) 
     * @param filteredExamStatus (optional) 
     * @param from (optional) Дата экзамена, с
     * @param to (optional) Дата экзамена, по
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getExpertExams(expertId: string | null, qualificationIds: string[] | null | undefined, examinationCenterIds: string[] | null | undefined, filteredExamStatus: FilteredExamStatus | undefined, from: moment.Moment | null | undefined, to: moment.Moment | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<ExamList> {
        let url_ = this.baseUrl + "/api/v1/experts/{expertId}/exams?";
        if (expertId === undefined || expertId === null)
            throw new Error("The parameter 'expertId' must be defined.");
        url_ = url_.replace("{expertId}", encodeURIComponent("" + expertId));
        if (qualificationIds !== undefined && qualificationIds !== null)
            qualificationIds && qualificationIds.forEach(item => { url_ += "qualificationIds=" + encodeURIComponent("" + item) + "&"; });
        if (examinationCenterIds !== undefined && examinationCenterIds !== null)
            examinationCenterIds && examinationCenterIds.forEach(item => { url_ += "examinationCenterIds=" + encodeURIComponent("" + item) + "&"; });
        if (filteredExamStatus === null)
            throw new Error("The parameter 'filteredExamStatus' cannot be null.");
        else if (filteredExamStatus !== undefined)
            url_ += "filteredExamStatus=" + encodeURIComponent("" + filteredExamStatus) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExpertExams(_response);
        });
    }

    protected processGetExpertExams(response: Response): Promise<ExamList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamList>(<any>null);
    }

    /**
     * Возвращает информацию о ЭЦ
     * @return Success
     */
    getInfo(): Promise<ExaminationCenterDetails> {
        let url_ = this.baseUrl + "/api/v1/ec-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInfo(_response);
        });
    }

    protected processGetInfo(response: Response): Promise<ExaminationCenterDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExaminationCenterDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExaminationCenterDetails>(<any>null);
    }

    /**
     * Возвращает список ЦОК
     * @param qualificationIds (optional) 
     * @param regionId (optional) 
     * @param searchField (optional) Поле, по которому осуществляется поиск
     * @param searchTerm (optional) Строка для поиска
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getQecs(qualificationIds: string[] | null | undefined, regionId: number | null | undefined, searchField: string | null | undefined, searchTerm: string | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<QualificationEvaluationCenters> {
        let url_ = this.baseUrl + "/api/v1/qualification-evaluation-centers?";
        if (qualificationIds !== undefined && qualificationIds !== null)
            qualificationIds && qualificationIds.forEach(item => { url_ += "qualificationIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId !== undefined && regionId !== null)
            url_ += "regionId=" + encodeURIComponent("" + regionId) + "&";
        if (searchField !== undefined && searchField !== null)
            url_ += "searchField=" + encodeURIComponent("" + searchField) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQecs(_response);
        });
    }

    protected processGetQecs(response: Response): Promise<QualificationEvaluationCenters> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QualificationEvaluationCenters.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QualificationEvaluationCenters>(<any>null);
    }

    /**
     * Возвращает информацию о ЦОК
     * @return Success
     */
    getQec(qecId: string): Promise<QualificationEvaluationCenterDetails> {
        let url_ = this.baseUrl + "/api/v1/qualification-evaluation-centers/{qecId}";
        if (qecId === undefined || qecId === null)
            throw new Error("The parameter 'qecId' must be defined.");
        url_ = url_.replace("{qecId}", encodeURIComponent("" + qecId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQec(_response);
        });
    }

    protected processGetQec(response: Response): Promise<QualificationEvaluationCenterDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QualificationEvaluationCenterDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QualificationEvaluationCenterDetails>(<any>null);
    }

    /**
     * Возвращает список аттестатов ЦОК
     * @return Успешно.
     */
    getQecCertificates(qecId: string): Promise<QecCertificate[]> {
        let url_ = this.baseUrl + "/api/v1/qualification-evaluation-centers/{qecId}/certificates";
        if (qecId === undefined || qecId === null)
            throw new Error("The parameter 'qecId' must be defined.");
        url_ = url_.replace("{qecId}", encodeURIComponent("" + qecId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQecCertificates(_response);
        });
    }

    protected processGetQecCertificates(response: Response): Promise<QecCertificate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QecCertificate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QecCertificate[]>(<any>null);
    }

    /**
     * Возвращает список квалификаций ЦОК
     * @return Успешно.
     */
    getQecQualifications(qecId: string): Promise<QecQualification[]> {
        let url_ = this.baseUrl + "/api/v1/qualification-evaluation-centers/{qecId}/qualifications";
        if (qecId === undefined || qecId === null)
            throw new Error("The parameter 'qecId' must be defined.");
        url_ = url_.replace("{qecId}", encodeURIComponent("" + qecId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQecQualifications(_response);
        });
    }

    protected processGetQecQualifications(response: Response): Promise<QecQualification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QecQualification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QecQualification[]>(<any>null);
    }

    /**
     * @param occupationalStandardId (optional) 
     * @param readyToUse (optional) 
     * @param searchField (optional) Поле, по которому осуществляется поиск
     * @param searchTerm (optional) Строка для поиска
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getQualifications(occupationalStandardId: string | null | undefined, readyToUse: boolean | null | undefined, searchField: string | null | undefined, searchTerm: string | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<QualificationInfoList> {
        let url_ = this.baseUrl + "/api/v1/qualifications?";
        if (occupationalStandardId !== undefined && occupationalStandardId !== null)
            url_ += "occupationalStandardId=" + encodeURIComponent("" + occupationalStandardId) + "&";
        if (readyToUse !== undefined && readyToUse !== null)
            url_ += "readyToUse=" + encodeURIComponent("" + readyToUse) + "&";
        if (searchField !== undefined && searchField !== null)
            url_ += "searchField=" + encodeURIComponent("" + searchField) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQualifications(_response);
        });
    }

    protected processGetQualifications(response: Response): Promise<QualificationInfoList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QualificationInfoList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QualificationInfoList>(<any>null);
    }

    /**
     * @param qecId (optional) 
     * @return Success
     */
    getQecQualifications2(qecId: string | undefined): Promise<QecQualification[]> {
        let url_ = this.baseUrl + "/api/v1/qualifications/with-extended-info-qec?";
        if (qecId === null)
            throw new Error("The parameter 'qecId' cannot be null.");
        else if (qecId !== undefined)
            url_ += "qecId=" + encodeURIComponent("" + qecId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQecQualifications2(_response);
        });
    }

    protected processGetQecQualifications2(response: Response): Promise<QecQualification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QecQualification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QecQualification[]>(<any>null);
    }

    /**
     * @return Success
     */
    getQualification(qualificationId: string): Promise<QualificationDetails> {
        let url_ = this.baseUrl + "/api/v1/qualifications/{qualificationId}";
        if (qualificationId === undefined || qualificationId === null)
            throw new Error("The parameter 'qualificationId' must be defined.");
        url_ = url_.replace("{qualificationId}", encodeURIComponent("" + qualificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQualification(_response);
        });
    }

    protected processGetQualification(response: Response): Promise<QualificationDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QualificationDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QualificationDetails>(<any>null);
    }

    /**
     * @return Success
     */
    getQualificationRules(qualificationId: string): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/qualifications/{qualificationId}/rules";
        if (qualificationId === undefined || qualificationId === null)
            throw new Error("The parameter 'qualificationId' must be defined.");
        url_ = url_.replace("{qualificationId}", encodeURIComponent("" + qualificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQualificationRules(_response);
        });
    }

    protected processGetQualificationRules(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @return Success
     */
    getQualificationDocumentTemplates(qualificationId: string): Promise<QualificationDocumentTemplate[]> {
        let url_ = this.baseUrl + "/api/v1/qualifications/{qualificationId}/document-templates";
        if (qualificationId === undefined || qualificationId === null)
            throw new Error("The parameter 'qualificationId' must be defined.");
        url_ = url_.replace("{qualificationId}", encodeURIComponent("" + qualificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQualificationDocumentTemplates(_response);
        });
    }

    protected processGetQualificationDocumentTemplates(response: Response): Promise<QualificationDocumentTemplate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QualificationDocumentTemplate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QualificationDocumentTemplate[]>(<any>null);
    }

    /**
     * @return Success
     */
    getRegions(): Promise<Region[]> {
        let url_ = this.baseUrl + "/api/v1/regions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRegions(_response);
        });
    }

    protected processGetRegions(response: Response): Promise<Region[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Region.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Region[]>(<any>null);
    }
}

export class AnswerPair implements IAnswerPair {
    /** Номер вопроса */
    number!: number;
    /** Номер соответствующего вопроса,
заполняется только в случае типов: Matching, Ordering */
    matchingNumber?: number;

    constructor(data?: IAnswerPair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.matchingNumber = _data["matchingNumber"];
        }
    }

    static fromJS(data: any): AnswerPair {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerPair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["matchingNumber"] = this.matchingNumber;
        return data; 
    }
}

export interface IAnswerPair {
    /** Номер вопроса */
    number: number;
    /** Номер соответствующего вопроса,
заполняется только в случае типов: Matching, Ordering */
    matchingNumber?: number;
}

export class ApiError implements IApiError {
    code!: number;
    type!: AppExceptionType;
    message!: string;
    failures?: { [key: string]: string[]; } | undefined;

    constructor(data?: IApiError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.type = _data["type"];
            this.message = _data["message"];
            if (_data["failures"]) {
                this.failures = {} as any;
                for (let key in _data["failures"]) {
                    if (_data["failures"].hasOwnProperty(key))
                        (<any>this.failures)![key] = _data["failures"][key] !== undefined ? _data["failures"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ApiError {
        data = typeof data === 'object' ? data : {};
        let result = new ApiError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["type"] = this.type;
        data["message"] = this.message;
        if (this.failures) {
            data["failures"] = {};
            for (let key in this.failures) {
                if (this.failures.hasOwnProperty(key))
                    (<any>data["failures"])[key] = this.failures[key];
            }
        }
        return data; 
    }
}

export interface IApiError {
    code: number;
    type: AppExceptionType;
    message: string;
    failures?: { [key: string]: string[]; } | undefined;
}

export enum AppExceptionType {
    Unspecified = "unspecified",
    Validation = "validation",
    NotFound = "notFound",
    AlreadyExists = "alreadyExists",
    WrongVerificationCode = "wrongVerificationCode",
    TooManyRequests = "tooManyRequests",
    WrongCredentials = "wrongCredentials",
    AuthUserNotFound = "authUserNotFound",
    Forbidden = "forbidden",
    Captcha = "captcha",
    WrongIp = "wrongIp",
}

export class Applicant implements IApplicant {
    id!: string;
    /** Имя */
    firstName!: string;
    /** Фамилия */
    lastName!: string;
    /** Отчество */
    middleName?: string | undefined;
    sex!: Sex;
    birthDate!: moment.Moment;
    email!: string;
    emailConfirmed!: boolean;
    phone!: string;
    isExpert!: boolean;

    constructor(data?: IApplicant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.sex = _data["sex"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.phone = _data["phone"];
            this.isExpert = _data["isExpert"];
        }
    }

    static fromJS(data: any): Applicant {
        data = typeof data === 'object' ? data : {};
        let result = new Applicant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["sex"] = this.sex;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["emailConfirmed"] = this.emailConfirmed;
        data["phone"] = this.phone;
        data["isExpert"] = this.isExpert;
        return data; 
    }
}

export interface IApplicant {
    id: string;
    /** Имя */
    firstName: string;
    /** Фамилия */
    lastName: string;
    /** Отчество */
    middleName?: string | undefined;
    sex: Sex;
    birthDate: moment.Moment;
    email: string;
    emailConfirmed: boolean;
    phone: string;
    isExpert: boolean;
}

export class ApplicantExam implements IApplicantExam {
    examId!: string;
    date!: moment.Moment;
    duration!: number;
    reviewComment?: string | undefined;
    examPrice!: number;
    qualificationTitle!: string;
    qualificationLevel!: string;
    occupationalStandardTitle!: string;
    examinationCenterName!: string;
    address!: string;
    qualificationEvaluationCenterName!: string;
    city!: string;
    examStatus!: ExamStatus;
    /** Переаттестация / Признание аттестата */
    recertification!: boolean;
    examType!: ExamType;
    /** Обработан в НАРК */
    processedByNark!: boolean;
    examApplicationStatus?: ExamApplicationStatus;
    applicationSubmitDate?: moment.Moment | undefined;
    examApplicationId?: string | undefined;

    constructor(data?: IApplicantExam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examId = _data["examId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.reviewComment = _data["reviewComment"];
            this.examPrice = _data["examPrice"];
            this.qualificationTitle = _data["qualificationTitle"];
            this.qualificationLevel = _data["qualificationLevel"];
            this.occupationalStandardTitle = _data["occupationalStandardTitle"];
            this.examinationCenterName = _data["examinationCenterName"];
            this.address = _data["address"];
            this.qualificationEvaluationCenterName = _data["qualificationEvaluationCenterName"];
            this.city = _data["city"];
            this.examStatus = _data["examStatus"];
            this.recertification = _data["recertification"];
            this.examType = _data["examType"];
            this.processedByNark = _data["processedByNark"];
            this.examApplicationStatus = _data["examApplicationStatus"];
            this.applicationSubmitDate = _data["applicationSubmitDate"] ? moment(_data["applicationSubmitDate"].toString()) : <any>undefined;
            this.examApplicationId = _data["examApplicationId"];
        }
    }

    static fromJS(data: any): ApplicantExam {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantExam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examId"] = this.examId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["reviewComment"] = this.reviewComment;
        data["examPrice"] = this.examPrice;
        data["qualificationTitle"] = this.qualificationTitle;
        data["qualificationLevel"] = this.qualificationLevel;
        data["occupationalStandardTitle"] = this.occupationalStandardTitle;
        data["examinationCenterName"] = this.examinationCenterName;
        data["address"] = this.address;
        data["qualificationEvaluationCenterName"] = this.qualificationEvaluationCenterName;
        data["city"] = this.city;
        data["examStatus"] = this.examStatus;
        data["recertification"] = this.recertification;
        data["examType"] = this.examType;
        data["processedByNark"] = this.processedByNark;
        data["examApplicationStatus"] = this.examApplicationStatus;
        data["applicationSubmitDate"] = this.applicationSubmitDate ? this.applicationSubmitDate.toISOString() : <any>undefined;
        data["examApplicationId"] = this.examApplicationId;
        return data; 
    }
}

export interface IApplicantExam {
    examId: string;
    date: moment.Moment;
    duration: number;
    reviewComment?: string | undefined;
    examPrice: number;
    qualificationTitle: string;
    qualificationLevel: string;
    occupationalStandardTitle: string;
    examinationCenterName: string;
    address: string;
    qualificationEvaluationCenterName: string;
    city: string;
    examStatus: ExamStatus;
    /** Переаттестация / Признание аттестата */
    recertification: boolean;
    examType: ExamType;
    /** Обработан в НАРК */
    processedByNark: boolean;
    examApplicationStatus?: ExamApplicationStatus;
    applicationSubmitDate?: moment.Moment | undefined;
    examApplicationId?: string | undefined;
}

export class ApplicantExamList implements IApplicantExamList {
    items!: ApplicantExam[];
    page!: number;
    pageSize!: number;
    total!: number;

    constructor(data?: IApplicantExamList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApplicantExam.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): ApplicantExamList {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantExamList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["total"] = this.total;
        return data; 
    }
}

export interface IApplicantExamList {
    items: ApplicantExam[];
    page: number;
    pageSize: number;
    total: number;
}

export class ApplicantIdentityDoc implements IApplicantIdentityDoc {
    identityDocType!: IdentityDocType;
    passport?: ApplicantPassport;
    otherIdentity?: ApplicantOtherIdentity;

    constructor(data?: IApplicantIdentityDoc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identityDocType = _data["identityDocType"];
            this.passport = _data["passport"] ? ApplicantPassport.fromJS(_data["passport"]) : <any>undefined;
            this.otherIdentity = _data["otherIdentity"] ? ApplicantOtherIdentity.fromJS(_data["otherIdentity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicantIdentityDoc {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantIdentityDoc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identityDocType"] = this.identityDocType;
        data["passport"] = this.passport ? this.passport.toJSON() : <any>undefined;
        data["otherIdentity"] = this.otherIdentity ? this.otherIdentity.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IApplicantIdentityDoc {
    identityDocType: IdentityDocType;
    passport?: ApplicantPassport;
    otherIdentity?: ApplicantOtherIdentity;
}

/** Другой документ */
export class ApplicantOtherIdentity implements IApplicantOtherIdentity {
    /** название документа */
    title!: string;
    /** данные документа */
    data!: string;

    constructor(data?: IApplicantOtherIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ApplicantOtherIdentity {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantOtherIdentity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["data"] = this.data;
        return data; 
    }
}

/** Другой документ */
export interface IApplicantOtherIdentity {
    /** название документа */
    title: string;
    /** данные документа */
    data: string;
}

/** паспорт */
export class ApplicantPassport implements IApplicantPassport {
    /** серия/номер */
    serialNumber!: string;
    /** кем выдан */
    issuedBy!: string;
    /** Дата выдачи, время должно быть 00ч. 00м. 00с. по UTC */
    dateOfIssue!: moment.Moment;
    /** адрес регистрации */
    registrationAddress!: string;

    constructor(data?: IApplicantPassport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["serialNumber"];
            this.issuedBy = _data["issuedBy"];
            this.dateOfIssue = _data["dateOfIssue"] ? moment(_data["dateOfIssue"].toString()) : <any>undefined;
            this.registrationAddress = _data["registrationAddress"];
        }
    }

    static fromJS(data: any): ApplicantPassport {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantPassport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        data["issuedBy"] = this.issuedBy;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toISOString() : <any>undefined;
        data["registrationAddress"] = this.registrationAddress;
        return data; 
    }
}

/** паспорт */
export interface IApplicantPassport {
    /** серия/номер */
    serialNumber: string;
    /** кем выдан */
    issuedBy: string;
    /** Дата выдачи, время должно быть 00ч. 00м. 00с. по UTC */
    dateOfIssue: moment.Moment;
    /** адрес регистрации */
    registrationAddress: string;
}

export class ApplicantQualification implements IApplicantQualification {
    applicantId!: string;
    examId!: string;
    examApplicationId!: string;
    title!: string;
    level!: string;
    /** Регистрационный номер квалификации */
    regNumber!: string;
    /** Дата присвоения */
    issueDate!: moment.Moment;
    /** Дата окончания действия */
    expireDate!: moment.Moment;
    /** Регистрационный номер свидетельства */
    certRegNumber!: string;

    constructor(data?: IApplicantQualification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantId = _data["applicantId"];
            this.examId = _data["examId"];
            this.examApplicationId = _data["examApplicationId"];
            this.title = _data["title"];
            this.level = _data["level"];
            this.regNumber = _data["regNumber"];
            this.issueDate = _data["issueDate"] ? moment(_data["issueDate"].toString()) : <any>undefined;
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
            this.certRegNumber = _data["certRegNumber"];
        }
    }

    static fromJS(data: any): ApplicantQualification {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantQualification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId;
        data["examId"] = this.examId;
        data["examApplicationId"] = this.examApplicationId;
        data["title"] = this.title;
        data["level"] = this.level;
        data["regNumber"] = this.regNumber;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["certRegNumber"] = this.certRegNumber;
        return data; 
    }
}

export interface IApplicantQualification {
    applicantId: string;
    examId: string;
    examApplicationId: string;
    title: string;
    level: string;
    /** Регистрационный номер квалификации */
    regNumber: string;
    /** Дата присвоения */
    issueDate: moment.Moment;
    /** Дата окончания действия */
    expireDate: moment.Moment;
    /** Регистрационный номер свидетельства */
    certRegNumber: string;
}

export class ApplicantQualificationDetails implements IApplicantQualificationDetails {
    applicantId!: string;
    examId!: string;
    examApplicationId!: string;
    title!: string;
    level!: string;
    /** Регистрационный номер квалификации */
    regNumber!: string;
    /** Дата присвоения */
    issueDate!: moment.Moment;
    /** Дата окончания действия */
    expireDate!: moment.Moment;
    /** Регистрационный номер свидетельства */
    certRegNumber!: string;
    examDate!: moment.Moment;
    occupationalStandardTitle!: string;
    qecFullName!: string;
    /** Секретный код НАРК */
    secretCode!: string;
    /** Ссылка на страницу реестр в НАРК */
    narkPageUrl!: string;
    /** Ссылка на документ в НАРК */
    narkDocUrl!: string;
    /** СВИДЕТЕЛЬСТВО О КВАЛИФИКАЦИИ */
    certificateUrl?: string | undefined;

    constructor(data?: IApplicantQualificationDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantId = _data["applicantId"];
            this.examId = _data["examId"];
            this.examApplicationId = _data["examApplicationId"];
            this.title = _data["title"];
            this.level = _data["level"];
            this.regNumber = _data["regNumber"];
            this.issueDate = _data["issueDate"] ? moment(_data["issueDate"].toString()) : <any>undefined;
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
            this.certRegNumber = _data["certRegNumber"];
            this.examDate = _data["examDate"] ? moment(_data["examDate"].toString()) : <any>undefined;
            this.occupationalStandardTitle = _data["occupationalStandardTitle"];
            this.qecFullName = _data["qecFullName"];
            this.secretCode = _data["secretCode"];
            this.narkPageUrl = _data["narkPageUrl"];
            this.narkDocUrl = _data["narkDocUrl"];
            this.certificateUrl = _data["certificateUrl"];
        }
    }

    static fromJS(data: any): ApplicantQualificationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantQualificationDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId;
        data["examId"] = this.examId;
        data["examApplicationId"] = this.examApplicationId;
        data["title"] = this.title;
        data["level"] = this.level;
        data["regNumber"] = this.regNumber;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["certRegNumber"] = this.certRegNumber;
        data["examDate"] = this.examDate ? this.examDate.toISOString() : <any>undefined;
        data["occupationalStandardTitle"] = this.occupationalStandardTitle;
        data["qecFullName"] = this.qecFullName;
        data["secretCode"] = this.secretCode;
        data["narkPageUrl"] = this.narkPageUrl;
        data["narkDocUrl"] = this.narkDocUrl;
        data["certificateUrl"] = this.certificateUrl;
        return data; 
    }
}

export interface IApplicantQualificationDetails {
    applicantId: string;
    examId: string;
    examApplicationId: string;
    title: string;
    level: string;
    /** Регистрационный номер квалификации */
    regNumber: string;
    /** Дата присвоения */
    issueDate: moment.Moment;
    /** Дата окончания действия */
    expireDate: moment.Moment;
    /** Регистрационный номер свидетельства */
    certRegNumber: string;
    examDate: moment.Moment;
    occupationalStandardTitle: string;
    qecFullName: string;
    /** Секретный код НАРК */
    secretCode: string;
    /** Ссылка на страницу реестр в НАРК */
    narkPageUrl: string;
    /** Ссылка на документ в НАРК */
    narkDocUrl: string;
    /** СВИДЕТЕЛЬСТВО О КВАЛИФИКАЦИИ */
    certificateUrl?: string | undefined;
}

export class Applicants implements IApplicants {
    items!: Applicant[];
    page!: number;
    pageSize!: number;
    total!: number;

    constructor(data?: IApplicants) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Applicant.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): Applicants {
        data = typeof data === 'object' ? data : {};
        let result = new Applicants();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["total"] = this.total;
        return data; 
    }
}

export interface IApplicants {
    items: Applicant[];
    page: number;
    pageSize: number;
    total: number;
}

export class AssignExpertsToExam implements IAssignExpertsToExam {
    /** Список идентификаторов экспертов, приглашенных для проведения экзамена */
    invitedExpertIds!: string[];
    /** Идентификатор председателя экзаменационной комиссии */
    committeeChairmanId!: string;

    constructor(data?: IAssignExpertsToExam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.invitedExpertIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["invitedExpertIds"])) {
                this.invitedExpertIds = [] as any;
                for (let item of _data["invitedExpertIds"])
                    this.invitedExpertIds!.push(item);
            }
            this.committeeChairmanId = _data["committeeChairmanId"];
        }
    }

    static fromJS(data: any): AssignExpertsToExam {
        data = typeof data === 'object' ? data : {};
        let result = new AssignExpertsToExam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invitedExpertIds)) {
            data["invitedExpertIds"] = [];
            for (let item of this.invitedExpertIds)
                data["invitedExpertIds"].push(item);
        }
        data["committeeChairmanId"] = this.committeeChairmanId;
        return data; 
    }
}

export interface IAssignExpertsToExam {
    /** Список идентификаторов экспертов, приглашенных для проведения экзамена */
    invitedExpertIds: string[];
    /** Идентификатор председателя экзаменационной комиссии */
    committeeChairmanId: string;
}

export class AuthResult implements IAuthResult {
    profile!: EcUserDetails;
    token!: string;

    constructor(data?: IAuthResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.profile = new EcUserDetails();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profile = _data["profile"] ? EcUserDetails.fromJS(_data["profile"]) : new EcUserDetails();
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): AuthResult {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
        data["token"] = this.token;
        return data; 
    }
}

export interface IAuthResult {
    profile: EcUserDetails;
    token: string;
}

export class AvailableExamExpert implements IAvailableExamExpert {
    id!: string;
    regNumber!: string;
    firstName!: string;
    lastName!: string;
    middleName!: string;
    birthDate!: moment.Moment;
    sex!: Sex;
    phone!: string;
    email!: string;
    regionId!: number;
    region!: string;
    sovietMember!: boolean;
    akMember!: boolean;
    nokMember!: boolean;
    chairman!: boolean;
    employee?: boolean | undefined;
    emailConfirmed!: boolean;
    registrationCompleted!: boolean;
    /** Должность в случае члена совета */
    position?: string | undefined;
    applicantId?: string | undefined;
    qualified?: boolean;

    constructor(data?: IAvailableExamExpert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regNumber = _data["regNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.sex = _data["sex"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.regionId = _data["regionId"];
            this.region = _data["region"];
            this.sovietMember = _data["sovietMember"];
            this.akMember = _data["akMember"];
            this.nokMember = _data["nokMember"];
            this.chairman = _data["chairman"];
            this.employee = _data["employee"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.registrationCompleted = _data["registrationCompleted"];
            this.position = _data["position"];
            this.applicantId = _data["applicantId"];
            this.qualified = _data["qualified"];
        }
    }

    static fromJS(data: any): AvailableExamExpert {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableExamExpert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regNumber"] = this.regNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["sex"] = this.sex;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["regionId"] = this.regionId;
        data["region"] = this.region;
        data["sovietMember"] = this.sovietMember;
        data["akMember"] = this.akMember;
        data["nokMember"] = this.nokMember;
        data["chairman"] = this.chairman;
        data["employee"] = this.employee;
        data["emailConfirmed"] = this.emailConfirmed;
        data["registrationCompleted"] = this.registrationCompleted;
        data["position"] = this.position;
        data["applicantId"] = this.applicantId;
        data["qualified"] = this.qualified;
        return data; 
    }
}

export interface IAvailableExamExpert {
    id: string;
    regNumber: string;
    firstName: string;
    lastName: string;
    middleName: string;
    birthDate: moment.Moment;
    sex: Sex;
    phone: string;
    email: string;
    regionId: number;
    region: string;
    sovietMember: boolean;
    akMember: boolean;
    nokMember: boolean;
    chairman: boolean;
    employee?: boolean | undefined;
    emailConfirmed: boolean;
    registrationCompleted: boolean;
    /** Должность в случае члена совета */
    position?: string | undefined;
    applicantId?: string | undefined;
    qualified?: boolean;
}

export class ChangePassword implements IChangePassword {
    captcha?: string | undefined;
    /** Старый пароль */
    oldPassword!: string;
    /** Новый пароль */
    newPassword!: string;

    constructor(data?: IChangePassword) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePassword {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePassword();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data; 
    }
}

export interface IChangePassword {
    captcha?: string | undefined;
    /** Старый пароль */
    oldPassword: string;
    /** Новый пароль */
    newPassword: string;
}

export class CheckAccountConfirmationToken implements ICheckAccountConfirmationToken {
    captcha?: string | undefined;
    token!: string;

    constructor(data?: ICheckAccountConfirmationToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): CheckAccountConfirmationToken {
        data = typeof data === 'object' ? data : {};
        let result = new CheckAccountConfirmationToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["token"] = this.token;
        return data; 
    }
}

export interface ICheckAccountConfirmationToken {
    captcha?: string | undefined;
    token: string;
}

export class CheckedCell implements ICheckedCell {
    standard!: string;
    solution?: string | undefined;
    correct!: boolean;

    constructor(data?: ICheckedCell) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standard = _data["standard"];
            this.solution = _data["solution"];
            this.correct = _data["correct"];
        }
    }

    static fromJS(data: any): CheckedCell {
        data = typeof data === 'object' ? data : {};
        let result = new CheckedCell();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standard"] = this.standard;
        data["solution"] = this.solution;
        data["correct"] = this.correct;
        return data; 
    }
}

export interface ICheckedCell {
    standard: string;
    solution?: string | undefined;
    correct: boolean;
}

export class CheckedTable implements ICheckedTable {
    caption?: string | undefined;
    columns!: Column[];
    readonly rows?: CheckedCell[][] | undefined;
    showCorrectAndApplicantAnswer!: boolean;
    applicantAnswerRows?: string[][] | undefined;
    correctAnswerRows?: string[][] | undefined;

    constructor(data?: ICheckedTable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.columns = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caption = _data["caption"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(Column.fromJS(item));
            }
            if (Array.isArray(_data["rows"])) {
                (<any>this).rows = [] as any;
                for (let item of _data["rows"])
                    (<any>this).rows!.push(item);
            }
            this.showCorrectAndApplicantAnswer = _data["showCorrectAndApplicantAnswer"];
            if (Array.isArray(_data["applicantAnswerRows"])) {
                this.applicantAnswerRows = [] as any;
                for (let item of _data["applicantAnswerRows"])
                    this.applicantAnswerRows!.push(item);
            }
            if (Array.isArray(_data["correctAnswerRows"])) {
                this.correctAnswerRows = [] as any;
                for (let item of _data["correctAnswerRows"])
                    this.correctAnswerRows!.push(item);
            }
        }
    }

    static fromJS(data: any): CheckedTable {
        data = typeof data === 'object' ? data : {};
        let result = new CheckedTable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caption"] = this.caption;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item);
        }
        data["showCorrectAndApplicantAnswer"] = this.showCorrectAndApplicantAnswer;
        if (Array.isArray(this.applicantAnswerRows)) {
            data["applicantAnswerRows"] = [];
            for (let item of this.applicantAnswerRows)
                data["applicantAnswerRows"].push(item);
        }
        if (Array.isArray(this.correctAnswerRows)) {
            data["correctAnswerRows"] = [];
            for (let item of this.correctAnswerRows)
                data["correctAnswerRows"].push(item);
        }
        return data; 
    }
}

export interface ICheckedTable {
    caption?: string | undefined;
    columns: Column[];
    rows?: CheckedCell[][] | undefined;
    showCorrectAndApplicantAnswer: boolean;
    applicantAnswerRows?: string[][] | undefined;
    correctAnswerRows?: string[][] | undefined;
}

export class CheckResetPasswordToken implements ICheckResetPasswordToken {
    captcha?: string | undefined;
    /** Токен верификации */
    token!: string;

    constructor(data?: ICheckResetPasswordToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): CheckResetPasswordToken {
        data = typeof data === 'object' ? data : {};
        let result = new CheckResetPasswordToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["token"] = this.token;
        return data; 
    }
}

export interface ICheckResetPasswordToken {
    captcha?: string | undefined;
    /** Токен верификации */
    token: string;
}

export class Column implements IColumn {
    header!: string;
    width!: number;
    readonly!: boolean;
    numeric!: boolean;
    key!: boolean;
    multiline!: boolean;

    constructor(data?: IColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"];
            this.width = _data["width"];
            this.readonly = _data["readonly"];
            this.numeric = _data["numeric"];
            this.key = _data["key"];
            this.multiline = _data["multiline"];
        }
    }

    static fromJS(data: any): Column {
        data = typeof data === 'object' ? data : {};
        let result = new Column();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header;
        data["width"] = this.width;
        data["readonly"] = this.readonly;
        data["numeric"] = this.numeric;
        data["key"] = this.key;
        data["multiline"] = this.multiline;
        return data; 
    }
}

export interface IColumn {
    header: string;
    width: number;
    readonly: boolean;
    numeric: boolean;
    key: boolean;
    multiline: boolean;
}

export class ConfirmAccount implements IConfirmAccount {
    captcha?: string | undefined;
    token!: string;
    password!: string;

    constructor(data?: IConfirmAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.token = _data["token"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ConfirmAccount {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["token"] = this.token;
        data["password"] = this.password;
        return data; 
    }
}

export interface IConfirmAccount {
    captcha?: string | undefined;
    token: string;
    password: string;
}

export class ConfirmEmailByToken implements IConfirmEmailByToken {
    captcha?: string | undefined;
    token!: string;

    constructor(data?: IConfirmEmailByToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): ConfirmEmailByToken {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmEmailByToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["token"] = this.token;
        return data; 
    }
}

export interface IConfirmEmailByToken {
    captcha?: string | undefined;
    token: string;
}

export class CreateExamApplicationByQec implements ICreateExamApplicationByQec {
    /** Фамилия */
    lastName!: string;
    /** Имя */
    firstName!: string;
    /** Отчество */
    middleName!: string;
    sex!: Sex;
    /** Дата рождения, время должно быть 00ч. 00м. 00с. по UTC */
    birthDate!: moment.Moment;
    identityDocType!: IdentityDocType;
    passport?: ApplicantPassport;
    otherIdentity?: ApplicantOtherIdentity;
    /** Номер телефона соискателя */
    phone!: string;
    /** Электронная почта соискателя */
    email?: string | undefined;
    /** Id экзамена */
    examId!: string;
    /** Временный пароль, будет установлен для профиля соискателя, если соискатель ранее не был зарегистрирован в системе */
    tempPassword!: string;

    constructor(data?: ICreateExamApplicationByQec) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.sex = _data["sex"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.identityDocType = _data["identityDocType"];
            this.passport = _data["passport"] ? ApplicantPassport.fromJS(_data["passport"]) : <any>undefined;
            this.otherIdentity = _data["otherIdentity"] ? ApplicantOtherIdentity.fromJS(_data["otherIdentity"]) : <any>undefined;
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.examId = _data["examId"];
            this.tempPassword = _data["tempPassword"];
        }
    }

    static fromJS(data: any): CreateExamApplicationByQec {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExamApplicationByQec();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["sex"] = this.sex;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["identityDocType"] = this.identityDocType;
        data["passport"] = this.passport ? this.passport.toJSON() : <any>undefined;
        data["otherIdentity"] = this.otherIdentity ? this.otherIdentity.toJSON() : <any>undefined;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["examId"] = this.examId;
        data["tempPassword"] = this.tempPassword;
        return data; 
    }
}

export interface ICreateExamApplicationByQec {
    /** Фамилия */
    lastName: string;
    /** Имя */
    firstName: string;
    /** Отчество */
    middleName: string;
    sex: Sex;
    /** Дата рождения, время должно быть 00ч. 00м. 00с. по UTC */
    birthDate: moment.Moment;
    identityDocType: IdentityDocType;
    passport?: ApplicantPassport;
    otherIdentity?: ApplicantOtherIdentity;
    /** Номер телефона соискателя */
    phone: string;
    /** Электронная почта соискателя */
    email?: string | undefined;
    /** Id экзамена */
    examId: string;
    /** Временный пароль, будет установлен для профиля соискателя, если соискатель ранее не был зарегистрирован в системе */
    tempPassword: string;
}

export class CreateExamByEc implements ICreateExamByEc {
    /** идентификатор квалификации */
    qualificationId!: string;
    /** Дата проведения экзамена */
    examDate!: moment.Moment;
    /** Список идентификаторов экспертов, приглашенных для проведения экзамена */
    invitedExpertIds!: string[];
    /** Идентификатор председателя экзаменационной комиссии */
    committeeChairmanId!: string;
    examType?: ExamType;
    /** Ограничение по максимально возможному количеству заявок */
    applicationsLimit?: number | undefined;
    /** Идентификатор ЦОК */
    qualificationEvaluationCenterId!: string;

    constructor(data?: ICreateExamByEc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.invitedExpertIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationId = _data["qualificationId"];
            this.examDate = _data["examDate"] ? moment(_data["examDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["invitedExpertIds"])) {
                this.invitedExpertIds = [] as any;
                for (let item of _data["invitedExpertIds"])
                    this.invitedExpertIds!.push(item);
            }
            this.committeeChairmanId = _data["committeeChairmanId"];
            this.examType = _data["examType"];
            this.applicationsLimit = _data["applicationsLimit"];
            this.qualificationEvaluationCenterId = _data["qualificationEvaluationCenterId"];
        }
    }

    static fromJS(data: any): CreateExamByEc {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExamByEc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationId"] = this.qualificationId;
        data["examDate"] = this.examDate ? this.examDate.toISOString() : <any>undefined;
        if (Array.isArray(this.invitedExpertIds)) {
            data["invitedExpertIds"] = [];
            for (let item of this.invitedExpertIds)
                data["invitedExpertIds"].push(item);
        }
        data["committeeChairmanId"] = this.committeeChairmanId;
        data["examType"] = this.examType;
        data["applicationsLimit"] = this.applicationsLimit;
        data["qualificationEvaluationCenterId"] = this.qualificationEvaluationCenterId;
        return data; 
    }
}

export interface ICreateExamByEc {
    /** идентификатор квалификации */
    qualificationId: string;
    /** Дата проведения экзамена */
    examDate: moment.Moment;
    /** Список идентификаторов экспертов, приглашенных для проведения экзамена */
    invitedExpertIds: string[];
    /** Идентификатор председателя экзаменационной комиссии */
    committeeChairmanId: string;
    examType?: ExamType;
    /** Ограничение по максимально возможному количеству заявок */
    applicationsLimit?: number | undefined;
    /** Идентификатор ЦОК */
    qualificationEvaluationCenterId: string;
}

export enum DocumentType {
    Other = "other",
    IdentityDoc = "identityDoc",
    SecondaryEducationConfirmation = "secondaryEducationConfirmation",
    HigherEducationConfirmation = "higherEducationConfirmation",
    WorkExperienceConfirmation = "workExperienceConfirmation",
    ContinuingEducationConfirmation = "continuingEducationConfirmation",
    CertificateForExchange = "certificateForExchange",
    NoCriminalRecord = "noCriminalRecord",
    QualificationCertificate = "qualificationCertificate",
    ConsentToProcessingPersonalData = "consentToProcessingPersonalData",
}

export class EcUserDetails implements IEcUserDetails {
    id!: string;
    firstName!: string;
    lastName!: string;
    middleName!: string;
    email!: string;
    phone!: string;
    examinationCenterId!: string;
    emailConfirmed!: boolean;
    ecInfo!: ExaminationCenter;
    region!: Region;

    constructor(data?: IEcUserDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ecInfo = new ExaminationCenter();
            this.region = new Region();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.examinationCenterId = _data["examinationCenterId"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.ecInfo = _data["ecInfo"] ? ExaminationCenter.fromJS(_data["ecInfo"]) : new ExaminationCenter();
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : new Region();
        }
    }

    static fromJS(data: any): EcUserDetails {
        data = typeof data === 'object' ? data : {};
        let result = new EcUserDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["examinationCenterId"] = this.examinationCenterId;
        data["emailConfirmed"] = this.emailConfirmed;
        data["ecInfo"] = this.ecInfo ? this.ecInfo.toJSON() : <any>undefined;
        data["region"] = this.region ? this.region.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IEcUserDetails {
    id: string;
    firstName: string;
    lastName: string;
    middleName: string;
    email: string;
    phone: string;
    examinationCenterId: string;
    emailConfirmed: boolean;
    ecInfo: ExaminationCenter;
    region: Region;
}

export class EssayAnswer implements IEssayAnswer {
    factual?: string | undefined;

    constructor(data?: IEssayAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.factual = _data["factual"];
        }
    }

    static fromJS(data: any): EssayAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new EssayAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factual"] = this.factual;
        return data; 
    }
}

export interface IEssayAnswer {
    factual?: string | undefined;
}

export class EventsStateHolder implements IEventsStateHolder {
    eventsState?: { [key: string]: number; } | undefined;

    constructor(data?: IEventsStateHolder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["eventsState"]) {
                this.eventsState = {} as any;
                for (let key in _data["eventsState"]) {
                    if (_data["eventsState"].hasOwnProperty(key))
                        (<any>this.eventsState)![key] = _data["eventsState"][key];
                }
            }
        }
    }

    static fromJS(data: any): EventsStateHolder {
        data = typeof data === 'object' ? data : {};
        let result = new EventsStateHolder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.eventsState) {
            data["eventsState"] = {};
            for (let key in this.eventsState) {
                if (this.eventsState.hasOwnProperty(key))
                    (<any>data["eventsState"])[key] = this.eventsState[key];
            }
        }
        return data; 
    }
}

export interface IEventsStateHolder {
    eventsState?: { [key: string]: number; } | undefined;
}

export class Exam implements IExam {
    id!: string;
    date!: moment.Moment;
    qualificationId!: string;
    examinationCenterId!: string;
    qualificationTitle!: string;
    qualificationLevel!: string;
    occupationalStandardTitle!: string;
    qualificationEvaluationCenterName!: string;
    examinationCenterName!: string;
    address!: string;
    city!: string;
    status!: ExamStatus;
    statusChangeTime!: moment.Moment;
    /** Продолжительность экзамена в минутах */
    duration!: number;
    price!: number;
    /** Переаттестация */
    recertification!: boolean;
    type!: ExamType;
    qualificationEvaluationCenterId!: string;
    numberOfApplicants!: number;
    protocolNumber?: number | undefined;

    constructor(data?: IExam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.qualificationId = _data["qualificationId"];
            this.examinationCenterId = _data["examinationCenterId"];
            this.qualificationTitle = _data["qualificationTitle"];
            this.qualificationLevel = _data["qualificationLevel"];
            this.occupationalStandardTitle = _data["occupationalStandardTitle"];
            this.qualificationEvaluationCenterName = _data["qualificationEvaluationCenterName"];
            this.examinationCenterName = _data["examinationCenterName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.status = _data["status"];
            this.statusChangeTime = _data["statusChangeTime"] ? moment(_data["statusChangeTime"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.price = _data["price"];
            this.recertification = _data["recertification"];
            this.type = _data["type"];
            this.qualificationEvaluationCenterId = _data["qualificationEvaluationCenterId"];
            this.numberOfApplicants = _data["numberOfApplicants"];
            this.protocolNumber = _data["protocolNumber"];
        }
    }

    static fromJS(data: any): Exam {
        data = typeof data === 'object' ? data : {};
        let result = new Exam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["qualificationId"] = this.qualificationId;
        data["examinationCenterId"] = this.examinationCenterId;
        data["qualificationTitle"] = this.qualificationTitle;
        data["qualificationLevel"] = this.qualificationLevel;
        data["occupationalStandardTitle"] = this.occupationalStandardTitle;
        data["qualificationEvaluationCenterName"] = this.qualificationEvaluationCenterName;
        data["examinationCenterName"] = this.examinationCenterName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["status"] = this.status;
        data["statusChangeTime"] = this.statusChangeTime ? this.statusChangeTime.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["price"] = this.price;
        data["recertification"] = this.recertification;
        data["type"] = this.type;
        data["qualificationEvaluationCenterId"] = this.qualificationEvaluationCenterId;
        data["numberOfApplicants"] = this.numberOfApplicants;
        data["protocolNumber"] = this.protocolNumber;
        return data; 
    }
}

export interface IExam {
    id: string;
    date: moment.Moment;
    qualificationId: string;
    examinationCenterId: string;
    qualificationTitle: string;
    qualificationLevel: string;
    occupationalStandardTitle: string;
    qualificationEvaluationCenterName: string;
    examinationCenterName: string;
    address: string;
    city: string;
    status: ExamStatus;
    statusChangeTime: moment.Moment;
    /** Продолжительность экзамена в минутах */
    duration: number;
    price: number;
    /** Переаттестация */
    recertification: boolean;
    type: ExamType;
    qualificationEvaluationCenterId: string;
    numberOfApplicants: number;
    protocolNumber?: number | undefined;
}

export class ExamApplication implements IExamApplication {
    status!: ExamApplicationStatus;
    finalized!: boolean;
    statusChangeTime!: moment.Moment;
    examSessionStatus?: ExamSessionStatus;
    recommendations?: string | undefined;
    examApplicationId!: string;
    applicationSubmitDate!: moment.Moment;
    /** Обработан в НАРК */
    processedByNark!: boolean;
    examSessionReadyStatus?: ExamSessionReadyStatuses;
    applicantId!: string;
    applicantFullName!: string;
    applicantPhone!: string;
    applicantEmail!: string;
    isExpert!: boolean;
    birthDate!: moment.Moment;
    correctTheoreticalAnswersPercentage?: number | undefined;

    constructor(data?: IExamApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.finalized = _data["finalized"];
            this.statusChangeTime = _data["statusChangeTime"] ? moment(_data["statusChangeTime"].toString()) : <any>undefined;
            this.examSessionStatus = _data["examSessionStatus"];
            this.recommendations = _data["recommendations"];
            this.examApplicationId = _data["examApplicationId"];
            this.applicationSubmitDate = _data["applicationSubmitDate"] ? moment(_data["applicationSubmitDate"].toString()) : <any>undefined;
            this.processedByNark = _data["processedByNark"];
            this.examSessionReadyStatus = _data["examSessionReadyStatus"];
            this.applicantId = _data["applicantId"];
            this.applicantFullName = _data["applicantFullName"];
            this.applicantPhone = _data["applicantPhone"];
            this.applicantEmail = _data["applicantEmail"];
            this.isExpert = _data["isExpert"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.correctTheoreticalAnswersPercentage = _data["correctTheoreticalAnswersPercentage"];
        }
    }

    static fromJS(data: any): ExamApplication {
        data = typeof data === 'object' ? data : {};
        let result = new ExamApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["finalized"] = this.finalized;
        data["statusChangeTime"] = this.statusChangeTime ? this.statusChangeTime.toISOString() : <any>undefined;
        data["examSessionStatus"] = this.examSessionStatus;
        data["recommendations"] = this.recommendations;
        data["examApplicationId"] = this.examApplicationId;
        data["applicationSubmitDate"] = this.applicationSubmitDate ? this.applicationSubmitDate.toISOString() : <any>undefined;
        data["processedByNark"] = this.processedByNark;
        data["examSessionReadyStatus"] = this.examSessionReadyStatus;
        data["applicantId"] = this.applicantId;
        data["applicantFullName"] = this.applicantFullName;
        data["applicantPhone"] = this.applicantPhone;
        data["applicantEmail"] = this.applicantEmail;
        data["isExpert"] = this.isExpert;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["correctTheoreticalAnswersPercentage"] = this.correctTheoreticalAnswersPercentage;
        return data; 
    }
}

export interface IExamApplication {
    status: ExamApplicationStatus;
    finalized: boolean;
    statusChangeTime: moment.Moment;
    examSessionStatus?: ExamSessionStatus;
    recommendations?: string | undefined;
    examApplicationId: string;
    applicationSubmitDate: moment.Moment;
    /** Обработан в НАРК */
    processedByNark: boolean;
    examSessionReadyStatus?: ExamSessionReadyStatuses;
    applicantId: string;
    applicantFullName: string;
    applicantPhone: string;
    applicantEmail: string;
    isExpert: boolean;
    birthDate: moment.Moment;
    correctTheoreticalAnswersPercentage?: number | undefined;
}

export class ExamApplicationDetails implements IExamApplicationDetails {
    status!: ExamApplicationStatus;
    finalized!: boolean;
    statusChangeTime!: moment.Moment;
    examSessionStatus?: ExamSessionStatus;
    recommendations?: string | undefined;
    examApplicationId!: string;
    applicationSubmitDate!: moment.Moment;
    /** Обработан в НАРК */
    processedByNark!: boolean;
    examSessionReadyStatus?: ExamSessionReadyStatuses;
    exam!: Exam;
    applicant!: Applicant;
    applicantIdentityDoc!: ApplicantIdentityDoc;
    documents!: ExamApplicationDocument[];
    reviewComment?: string | undefined;
    agreementUrl?: string | undefined;
    /** Ссылка на страницу реестр в НАРК */
    narkPageUrl?: string | undefined;
    /** СВИДЕТЕЛЬСТВО О КВАЛИФИКАЦИИ */
    certificateUrl?: string | undefined;
    certificateDeliveryAddress?: string | undefined;
    isPassedTheory?: boolean | undefined;
    editableApplicant?: boolean | undefined;
    signCode?: string | undefined;
    approveCode?: string | undefined;
    eventsState?: { [key: string]: number; } | undefined;

    constructor(data?: IExamApplicationDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.exam = new Exam();
            this.applicant = new Applicant();
            this.applicantIdentityDoc = new ApplicantIdentityDoc();
            this.documents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.finalized = _data["finalized"];
            this.statusChangeTime = _data["statusChangeTime"] ? moment(_data["statusChangeTime"].toString()) : <any>undefined;
            this.examSessionStatus = _data["examSessionStatus"];
            this.recommendations = _data["recommendations"];
            this.examApplicationId = _data["examApplicationId"];
            this.applicationSubmitDate = _data["applicationSubmitDate"] ? moment(_data["applicationSubmitDate"].toString()) : <any>undefined;
            this.processedByNark = _data["processedByNark"];
            this.examSessionReadyStatus = _data["examSessionReadyStatus"];
            this.exam = _data["exam"] ? Exam.fromJS(_data["exam"]) : new Exam();
            this.applicant = _data["applicant"] ? Applicant.fromJS(_data["applicant"]) : new Applicant();
            this.applicantIdentityDoc = _data["applicantIdentityDoc"] ? ApplicantIdentityDoc.fromJS(_data["applicantIdentityDoc"]) : new ApplicantIdentityDoc();
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(ExamApplicationDocument.fromJS(item));
            }
            this.reviewComment = _data["reviewComment"];
            this.agreementUrl = _data["agreementUrl"];
            this.narkPageUrl = _data["narkPageUrl"];
            this.certificateUrl = _data["certificateUrl"];
            this.certificateDeliveryAddress = _data["certificateDeliveryAddress"];
            this.isPassedTheory = _data["isPassedTheory"];
            this.editableApplicant = _data["editableApplicant"];
            this.signCode = _data["signCode"];
            this.approveCode = _data["approveCode"];
            if (_data["eventsState"]) {
                this.eventsState = {} as any;
                for (let key in _data["eventsState"]) {
                    if (_data["eventsState"].hasOwnProperty(key))
                        (<any>this.eventsState)![key] = _data["eventsState"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExamApplicationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ExamApplicationDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["finalized"] = this.finalized;
        data["statusChangeTime"] = this.statusChangeTime ? this.statusChangeTime.toISOString() : <any>undefined;
        data["examSessionStatus"] = this.examSessionStatus;
        data["recommendations"] = this.recommendations;
        data["examApplicationId"] = this.examApplicationId;
        data["applicationSubmitDate"] = this.applicationSubmitDate ? this.applicationSubmitDate.toISOString() : <any>undefined;
        data["processedByNark"] = this.processedByNark;
        data["examSessionReadyStatus"] = this.examSessionReadyStatus;
        data["exam"] = this.exam ? this.exam.toJSON() : <any>undefined;
        data["applicant"] = this.applicant ? this.applicant.toJSON() : <any>undefined;
        data["applicantIdentityDoc"] = this.applicantIdentityDoc ? this.applicantIdentityDoc.toJSON() : <any>undefined;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["reviewComment"] = this.reviewComment;
        data["agreementUrl"] = this.agreementUrl;
        data["narkPageUrl"] = this.narkPageUrl;
        data["certificateUrl"] = this.certificateUrl;
        data["certificateDeliveryAddress"] = this.certificateDeliveryAddress;
        data["isPassedTheory"] = this.isPassedTheory;
        data["editableApplicant"] = this.editableApplicant;
        data["signCode"] = this.signCode;
        data["approveCode"] = this.approveCode;
        if (this.eventsState) {
            data["eventsState"] = {};
            for (let key in this.eventsState) {
                if (this.eventsState.hasOwnProperty(key))
                    (<any>data["eventsState"])[key] = this.eventsState[key];
            }
        }
        return data; 
    }
}

export interface IExamApplicationDetails {
    status: ExamApplicationStatus;
    finalized: boolean;
    statusChangeTime: moment.Moment;
    examSessionStatus?: ExamSessionStatus;
    recommendations?: string | undefined;
    examApplicationId: string;
    applicationSubmitDate: moment.Moment;
    /** Обработан в НАРК */
    processedByNark: boolean;
    examSessionReadyStatus?: ExamSessionReadyStatuses;
    exam: Exam;
    applicant: Applicant;
    applicantIdentityDoc: ApplicantIdentityDoc;
    documents: ExamApplicationDocument[];
    reviewComment?: string | undefined;
    agreementUrl?: string | undefined;
    /** Ссылка на страницу реестр в НАРК */
    narkPageUrl?: string | undefined;
    /** СВИДЕТЕЛЬСТВО О КВАЛИФИКАЦИИ */
    certificateUrl?: string | undefined;
    certificateDeliveryAddress?: string | undefined;
    isPassedTheory?: boolean | undefined;
    editableApplicant?: boolean | undefined;
    signCode?: string | undefined;
    approveCode?: string | undefined;
    eventsState?: { [key: string]: number; } | undefined;
}

export class ExamApplicationDocument implements IExamApplicationDocument {
    readonly fileId!: string;
    readonly fileExtension!: string;
    readonly fileSize!: number;
    readonly fileUrl!: string;
    id!: string;
    documentDescription!: string;
    variant!: number;
    type!: DocumentType;
    documentTemplateId?: string | undefined;
    examApplicationId!: string;
    applicantId!: string;
    submissionDate!: moment.Moment;
    readonly sourceFiles!: SourceFile[];

    constructor(data?: IExamApplicationDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sourceFiles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).fileId = _data["fileId"];
            (<any>this).fileExtension = _data["fileExtension"];
            (<any>this).fileSize = _data["fileSize"];
            (<any>this).fileUrl = _data["fileUrl"];
            this.id = _data["id"];
            this.documentDescription = _data["documentDescription"];
            this.variant = _data["variant"];
            this.type = _data["type"];
            this.documentTemplateId = _data["documentTemplateId"];
            this.examApplicationId = _data["examApplicationId"];
            this.applicantId = _data["applicantId"];
            this.submissionDate = _data["submissionDate"] ? moment(_data["submissionDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["sourceFiles"])) {
                (<any>this).sourceFiles = [] as any;
                for (let item of _data["sourceFiles"])
                    (<any>this).sourceFiles!.push(SourceFile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExamApplicationDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ExamApplicationDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileExtension"] = this.fileExtension;
        data["fileSize"] = this.fileSize;
        data["fileUrl"] = this.fileUrl;
        data["id"] = this.id;
        data["documentDescription"] = this.documentDescription;
        data["variant"] = this.variant;
        data["type"] = this.type;
        data["documentTemplateId"] = this.documentTemplateId;
        data["examApplicationId"] = this.examApplicationId;
        data["applicantId"] = this.applicantId;
        data["submissionDate"] = this.submissionDate ? this.submissionDate.toISOString() : <any>undefined;
        if (Array.isArray(this.sourceFiles)) {
            data["sourceFiles"] = [];
            for (let item of this.sourceFiles)
                data["sourceFiles"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IExamApplicationDocument {
    fileId: string;
    fileExtension: string;
    fileSize: number;
    fileUrl: string;
    id: string;
    documentDescription: string;
    variant: number;
    type: DocumentType;
    documentTemplateId?: string | undefined;
    examApplicationId: string;
    applicantId: string;
    submissionDate: moment.Moment;
    sourceFiles: SourceFile[];
}

export class ExamApplicationList implements IExamApplicationList {
    items!: ExamApplication[];
    page!: number;
    pageSize!: number;
    total!: number;
    admittedCount!: number;
    eventsState?: { [key: string]: number; } | undefined;

    constructor(data?: IExamApplicationList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExamApplication.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.total = _data["total"];
            this.admittedCount = _data["admittedCount"];
            if (_data["eventsState"]) {
                this.eventsState = {} as any;
                for (let key in _data["eventsState"]) {
                    if (_data["eventsState"].hasOwnProperty(key))
                        (<any>this.eventsState)![key] = _data["eventsState"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExamApplicationList {
        data = typeof data === 'object' ? data : {};
        let result = new ExamApplicationList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["total"] = this.total;
        data["admittedCount"] = this.admittedCount;
        if (this.eventsState) {
            data["eventsState"] = {};
            for (let key in this.eventsState) {
                if (this.eventsState.hasOwnProperty(key))
                    (<any>data["eventsState"])[key] = this.eventsState[key];
            }
        }
        return data; 
    }
}

export interface IExamApplicationList {
    items: ExamApplication[];
    page: number;
    pageSize: number;
    total: number;
    admittedCount: number;
    eventsState?: { [key: string]: number; } | undefined;
}

export enum ExamApplicationStatus {
    Draft = "draft",
    InReview = "inReview",
    CorrectionsRequired = "correctionsRequired",
    PaymentRequired = "paymentRequired",
    Canceled = "canceled",
    Paid = "paid",
    AdmittedToExam = "admittedToExam",
    IsPassing = "isPassing",
    Absent = "absent",
    NotPassed = "notPassed",
    Passed = "passed",
}

export class ExamDetails implements IExamDetails {
    id!: string;
    date!: moment.Moment;
    qualificationId!: string;
    examinationCenterId!: string;
    qualificationTitle!: string;
    qualificationLevel!: string;
    occupationalStandardTitle!: string;
    qualificationEvaluationCenterName!: string;
    examinationCenterName!: string;
    address!: string;
    city!: string;
    status!: ExamStatus;
    statusChangeTime!: moment.Moment;
    /** Продолжительность экзамена в минутах */
    duration!: number;
    price!: number;
    /** Переаттестация */
    recertification!: boolean;
    type!: ExamType;
    qualificationEvaluationCenterId!: string;
    numberOfApplicants!: number;
    protocolNumber?: number | undefined;
    /** Список экспертов экзаменационной комиссии / подписантов протокола НОК */
    experts!: ExamExpert[];
    /** Список подписантов протокола АК */
    akExperts!: ExamExpert[];
    /** Список подписантов протокола совета */
    sovietExperts!: ExamExpert[];
    actualStartTime?: moment.Moment | undefined;
    actualFinishTime?: moment.Moment | undefined;
    manualCheck!: boolean;
    examLogs!: ExamLog[];
    nokProtocolUrl?: string | undefined;
    akProtocolUrl?: string | undefined;
    sovietProtocolUrl?: string | undefined;
    rules?: string | undefined;
    theoreticalQuestionsCount!: number;
    theoreticalPartDuration!: number;
    practicalQuestionsCount!: number;
    practicalPartDuration!: number;
    protocolDate?: moment.Moment | undefined;
    practiceDefense!: boolean;
    /** Количество мест */
    applicationsLimit?: number | undefined;
    eventsState?: { [key: string]: number; } | undefined;

    constructor(data?: IExamDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.experts = [];
            this.akExperts = [];
            this.sovietExperts = [];
            this.examLogs = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.qualificationId = _data["qualificationId"];
            this.examinationCenterId = _data["examinationCenterId"];
            this.qualificationTitle = _data["qualificationTitle"];
            this.qualificationLevel = _data["qualificationLevel"];
            this.occupationalStandardTitle = _data["occupationalStandardTitle"];
            this.qualificationEvaluationCenterName = _data["qualificationEvaluationCenterName"];
            this.examinationCenterName = _data["examinationCenterName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.status = _data["status"];
            this.statusChangeTime = _data["statusChangeTime"] ? moment(_data["statusChangeTime"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.price = _data["price"];
            this.recertification = _data["recertification"];
            this.type = _data["type"];
            this.qualificationEvaluationCenterId = _data["qualificationEvaluationCenterId"];
            this.numberOfApplicants = _data["numberOfApplicants"];
            this.protocolNumber = _data["protocolNumber"];
            if (Array.isArray(_data["experts"])) {
                this.experts = [] as any;
                for (let item of _data["experts"])
                    this.experts!.push(ExamExpert.fromJS(item));
            }
            if (Array.isArray(_data["akExperts"])) {
                this.akExperts = [] as any;
                for (let item of _data["akExperts"])
                    this.akExperts!.push(ExamExpert.fromJS(item));
            }
            if (Array.isArray(_data["sovietExperts"])) {
                this.sovietExperts = [] as any;
                for (let item of _data["sovietExperts"])
                    this.sovietExperts!.push(ExamExpert.fromJS(item));
            }
            this.actualStartTime = _data["actualStartTime"] ? moment(_data["actualStartTime"].toString()) : <any>undefined;
            this.actualFinishTime = _data["actualFinishTime"] ? moment(_data["actualFinishTime"].toString()) : <any>undefined;
            this.manualCheck = _data["manualCheck"];
            if (Array.isArray(_data["examLogs"])) {
                this.examLogs = [] as any;
                for (let item of _data["examLogs"])
                    this.examLogs!.push(ExamLog.fromJS(item));
            }
            this.nokProtocolUrl = _data["nokProtocolUrl"];
            this.akProtocolUrl = _data["akProtocolUrl"];
            this.sovietProtocolUrl = _data["sovietProtocolUrl"];
            this.rules = _data["rules"];
            this.theoreticalQuestionsCount = _data["theoreticalQuestionsCount"];
            this.theoreticalPartDuration = _data["theoreticalPartDuration"];
            this.practicalQuestionsCount = _data["practicalQuestionsCount"];
            this.practicalPartDuration = _data["practicalPartDuration"];
            this.protocolDate = _data["protocolDate"] ? moment(_data["protocolDate"].toString()) : <any>undefined;
            this.practiceDefense = _data["practiceDefense"];
            this.applicationsLimit = _data["applicationsLimit"];
            if (_data["eventsState"]) {
                this.eventsState = {} as any;
                for (let key in _data["eventsState"]) {
                    if (_data["eventsState"].hasOwnProperty(key))
                        (<any>this.eventsState)![key] = _data["eventsState"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExamDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ExamDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["qualificationId"] = this.qualificationId;
        data["examinationCenterId"] = this.examinationCenterId;
        data["qualificationTitle"] = this.qualificationTitle;
        data["qualificationLevel"] = this.qualificationLevel;
        data["occupationalStandardTitle"] = this.occupationalStandardTitle;
        data["qualificationEvaluationCenterName"] = this.qualificationEvaluationCenterName;
        data["examinationCenterName"] = this.examinationCenterName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["status"] = this.status;
        data["statusChangeTime"] = this.statusChangeTime ? this.statusChangeTime.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["price"] = this.price;
        data["recertification"] = this.recertification;
        data["type"] = this.type;
        data["qualificationEvaluationCenterId"] = this.qualificationEvaluationCenterId;
        data["numberOfApplicants"] = this.numberOfApplicants;
        data["protocolNumber"] = this.protocolNumber;
        if (Array.isArray(this.experts)) {
            data["experts"] = [];
            for (let item of this.experts)
                data["experts"].push(item.toJSON());
        }
        if (Array.isArray(this.akExperts)) {
            data["akExperts"] = [];
            for (let item of this.akExperts)
                data["akExperts"].push(item.toJSON());
        }
        if (Array.isArray(this.sovietExperts)) {
            data["sovietExperts"] = [];
            for (let item of this.sovietExperts)
                data["sovietExperts"].push(item.toJSON());
        }
        data["actualStartTime"] = this.actualStartTime ? this.actualStartTime.toISOString() : <any>undefined;
        data["actualFinishTime"] = this.actualFinishTime ? this.actualFinishTime.toISOString() : <any>undefined;
        data["manualCheck"] = this.manualCheck;
        if (Array.isArray(this.examLogs)) {
            data["examLogs"] = [];
            for (let item of this.examLogs)
                data["examLogs"].push(item.toJSON());
        }
        data["nokProtocolUrl"] = this.nokProtocolUrl;
        data["akProtocolUrl"] = this.akProtocolUrl;
        data["sovietProtocolUrl"] = this.sovietProtocolUrl;
        data["rules"] = this.rules;
        data["theoreticalQuestionsCount"] = this.theoreticalQuestionsCount;
        data["theoreticalPartDuration"] = this.theoreticalPartDuration;
        data["practicalQuestionsCount"] = this.practicalQuestionsCount;
        data["practicalPartDuration"] = this.practicalPartDuration;
        data["protocolDate"] = this.protocolDate ? this.protocolDate.toISOString() : <any>undefined;
        data["practiceDefense"] = this.practiceDefense;
        data["applicationsLimit"] = this.applicationsLimit;
        if (this.eventsState) {
            data["eventsState"] = {};
            for (let key in this.eventsState) {
                if (this.eventsState.hasOwnProperty(key))
                    (<any>data["eventsState"])[key] = this.eventsState[key];
            }
        }
        return data; 
    }
}

export interface IExamDetails {
    id: string;
    date: moment.Moment;
    qualificationId: string;
    examinationCenterId: string;
    qualificationTitle: string;
    qualificationLevel: string;
    occupationalStandardTitle: string;
    qualificationEvaluationCenterName: string;
    examinationCenterName: string;
    address: string;
    city: string;
    status: ExamStatus;
    statusChangeTime: moment.Moment;
    /** Продолжительность экзамена в минутах */
    duration: number;
    price: number;
    /** Переаттестация */
    recertification: boolean;
    type: ExamType;
    qualificationEvaluationCenterId: string;
    numberOfApplicants: number;
    protocolNumber?: number | undefined;
    /** Список экспертов экзаменационной комиссии / подписантов протокола НОК */
    experts: ExamExpert[];
    /** Список подписантов протокола АК */
    akExperts: ExamExpert[];
    /** Список подписантов протокола совета */
    sovietExperts: ExamExpert[];
    actualStartTime?: moment.Moment | undefined;
    actualFinishTime?: moment.Moment | undefined;
    manualCheck: boolean;
    examLogs: ExamLog[];
    nokProtocolUrl?: string | undefined;
    akProtocolUrl?: string | undefined;
    sovietProtocolUrl?: string | undefined;
    rules?: string | undefined;
    theoreticalQuestionsCount: number;
    theoreticalPartDuration: number;
    practicalQuestionsCount: number;
    practicalPartDuration: number;
    protocolDate?: moment.Moment | undefined;
    practiceDefense: boolean;
    /** Количество мест */
    applicationsLimit?: number | undefined;
    eventsState?: { [key: string]: number; } | undefined;
}

export class ExamExpert implements IExamExpert {
    regNumber!: string;
    expertId!: string;
    fullName!: string;
    email!: string;
    phone!: string;
    region!: string;
    /** Эксперт доступен для подписи протокола */
    active!: boolean;
    /** Протокол пописан экспертом */
    signed!: boolean;
    chairman!: boolean;
    acceptedInvite?: boolean | undefined;
    position?: string | undefined;
    signedCode?: string | undefined;

    constructor(data?: IExamExpert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regNumber = _data["regNumber"];
            this.expertId = _data["expertId"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.region = _data["region"];
            this.active = _data["active"];
            this.signed = _data["signed"];
            this.chairman = _data["chairman"];
            this.acceptedInvite = _data["acceptedInvite"];
            this.position = _data["position"];
            this.signedCode = _data["signedCode"];
        }
    }

    static fromJS(data: any): ExamExpert {
        data = typeof data === 'object' ? data : {};
        let result = new ExamExpert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regNumber"] = this.regNumber;
        data["expertId"] = this.expertId;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["region"] = this.region;
        data["active"] = this.active;
        data["signed"] = this.signed;
        data["chairman"] = this.chairman;
        data["acceptedInvite"] = this.acceptedInvite;
        data["position"] = this.position;
        data["signedCode"] = this.signedCode;
        return data; 
    }
}

export interface IExamExpert {
    regNumber: string;
    expertId: string;
    fullName: string;
    email: string;
    phone: string;
    region: string;
    /** Эксперт доступен для подписи протокола */
    active: boolean;
    /** Протокол пописан экспертом */
    signed: boolean;
    chairman: boolean;
    acceptedInvite?: boolean | undefined;
    position?: string | undefined;
    signedCode?: string | undefined;
}

export class ExaminationCenter implements IExaminationCenter {
    id!: string;
    regNumber!: string;
    name!: string;
    fullName!: string;
    city!: string;
    address!: string;
    /** Id региона */
    regionId!: number;
    host!: string;
    default!: boolean;

    constructor(data?: IExaminationCenter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regNumber = _data["regNumber"];
            this.name = _data["name"];
            this.fullName = _data["fullName"];
            this.city = _data["city"];
            this.address = _data["address"];
            this.regionId = _data["regionId"];
            this.host = _data["host"];
            this.default = _data["default"];
        }
    }

    static fromJS(data: any): ExaminationCenter {
        data = typeof data === 'object' ? data : {};
        let result = new ExaminationCenter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regNumber"] = this.regNumber;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["city"] = this.city;
        data["address"] = this.address;
        data["regionId"] = this.regionId;
        data["host"] = this.host;
        data["default"] = this.default;
        return data; 
    }
}

export interface IExaminationCenter {
    id: string;
    regNumber: string;
    name: string;
    fullName: string;
    city: string;
    address: string;
    /** Id региона */
    regionId: number;
    host: string;
    default: boolean;
}

export class ExaminationCenterDetails implements IExaminationCenterDetails {
    id!: string;
    regNumber!: string;
    name!: string;
    fullName!: string;
    city!: string;
    address!: string;
    /** Id региона */
    regionId!: number;
    host!: string;
    default!: boolean;
    inn!: string;
    ogrn!: string;
    kpp!: string;
    directorsName!: string;
    legalAddress!: string;
    bankAccountNumber!: string;
    bankName!: string;
    bankBIK!: string;
    bankCorrespondentAccountNumber!: string;
    phones!: Phone[];
    faxes!: Fax[];
    emails!: string[];
    website!: string;
    agreementWithSpkfr!: string;

    constructor(data?: IExaminationCenterDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.phones = [];
            this.faxes = [];
            this.emails = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regNumber = _data["regNumber"];
            this.name = _data["name"];
            this.fullName = _data["fullName"];
            this.city = _data["city"];
            this.address = _data["address"];
            this.regionId = _data["regionId"];
            this.host = _data["host"];
            this.default = _data["default"];
            this.inn = _data["inn"];
            this.ogrn = _data["ogrn"];
            this.kpp = _data["kpp"];
            this.directorsName = _data["directorsName"];
            this.legalAddress = _data["legalAddress"];
            this.bankAccountNumber = _data["bankAccountNumber"];
            this.bankName = _data["bankName"];
            this.bankBIK = _data["bankBIK"];
            this.bankCorrespondentAccountNumber = _data["bankCorrespondentAccountNumber"];
            if (Array.isArray(_data["phones"])) {
                this.phones = [] as any;
                for (let item of _data["phones"])
                    this.phones!.push(Phone.fromJS(item));
            }
            if (Array.isArray(_data["faxes"])) {
                this.faxes = [] as any;
                for (let item of _data["faxes"])
                    this.faxes!.push(Fax.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
            this.website = _data["website"];
            this.agreementWithSpkfr = _data["agreementWithSpkfr"];
        }
    }

    static fromJS(data: any): ExaminationCenterDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ExaminationCenterDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regNumber"] = this.regNumber;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["city"] = this.city;
        data["address"] = this.address;
        data["regionId"] = this.regionId;
        data["host"] = this.host;
        data["default"] = this.default;
        data["inn"] = this.inn;
        data["ogrn"] = this.ogrn;
        data["kpp"] = this.kpp;
        data["directorsName"] = this.directorsName;
        data["legalAddress"] = this.legalAddress;
        data["bankAccountNumber"] = this.bankAccountNumber;
        data["bankName"] = this.bankName;
        data["bankBIK"] = this.bankBIK;
        data["bankCorrespondentAccountNumber"] = this.bankCorrespondentAccountNumber;
        if (Array.isArray(this.phones)) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        if (Array.isArray(this.faxes)) {
            data["faxes"] = [];
            for (let item of this.faxes)
                data["faxes"].push(item.toJSON());
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        data["website"] = this.website;
        data["agreementWithSpkfr"] = this.agreementWithSpkfr;
        return data; 
    }
}

export interface IExaminationCenterDetails {
    id: string;
    regNumber: string;
    name: string;
    fullName: string;
    city: string;
    address: string;
    /** Id региона */
    regionId: number;
    host: string;
    default: boolean;
    inn: string;
    ogrn: string;
    kpp: string;
    directorsName: string;
    legalAddress: string;
    bankAccountNumber: string;
    bankName: string;
    bankBIK: string;
    bankCorrespondentAccountNumber: string;
    phones: Phone[];
    faxes: Fax[];
    emails: string[];
    website: string;
    agreementWithSpkfr: string;
}

export class ExamList implements IExamList {
    items!: Exam[];
    page!: number;
    pageSize!: number;
    total!: number;
    eventsState?: { [key: string]: number; } | undefined;

    constructor(data?: IExamList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Exam.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.total = _data["total"];
            if (_data["eventsState"]) {
                this.eventsState = {} as any;
                for (let key in _data["eventsState"]) {
                    if (_data["eventsState"].hasOwnProperty(key))
                        (<any>this.eventsState)![key] = _data["eventsState"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExamList {
        data = typeof data === 'object' ? data : {};
        let result = new ExamList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["total"] = this.total;
        if (this.eventsState) {
            data["eventsState"] = {};
            for (let key in this.eventsState) {
                if (this.eventsState.hasOwnProperty(key))
                    (<any>data["eventsState"])[key] = this.eventsState[key];
            }
        }
        return data; 
    }
}

export interface IExamList {
    items: Exam[];
    page: number;
    pageSize: number;
    total: number;
    eventsState?: { [key: string]: number; } | undefined;
}

export class ExamLog implements IExamLog {
    statusText!: string;
    time!: moment.Moment;

    constructor(data?: IExamLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusText = _data["statusText"];
            this.time = _data["time"] ? moment(_data["time"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExamLog {
        data = typeof data === 'object' ? data : {};
        let result = new ExamLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusText"] = this.statusText;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IExamLog {
    statusText: string;
    time: moment.Moment;
}

export class ExamSessionDetails implements IExamSessionDetails {
    readonly examApplicationId!: string;
    readonly applicantId!: string;
    id!: string;
    examId!: string;
    startTime!: moment.Moment;
    readonly theoryFinishTime?: moment.Moment | undefined;
    readonly practiceStartTime?: moment.Moment | undefined;
    isPassedTheory!: boolean;
    readonly passed?: boolean | undefined;
    readonly finishTime?: moment.Moment | undefined;
    totalTimeInMinutes!: number;
    readonly theoreticalPassPercentage!: number;
    readonly totalPassPercentage!: number;
    readonly correctTheoreticalAnswersPercentage!: number;
    theoreticalPartDuration!: number;
    practicalPartDuration!: number;
    readonly isPassedPractice?: boolean | undefined;
    readonly correctPracticalAnswersPercentage!: number;
    readonly factualTheoreticalQuestionAnswers!: FactualTheoreticalQuestionAnswer[];
    readonly factualPracticalQuestionAnswers!: FactualPracticalQuestionAnswer[];
    manualCheck!: boolean;
    theoreticalQuestions!: TheoreticalQuestion[];
    practicalQuestions?: PracticalQuestion[] | undefined;
    readonly criteriaForRate?: string | undefined;

    constructor(data?: IExamSessionDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.factualTheoreticalQuestionAnswers = [];
            this.factualPracticalQuestionAnswers = [];
            this.theoreticalQuestions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).examApplicationId = _data["examApplicationId"];
            (<any>this).applicantId = _data["applicantId"];
            this.id = _data["id"];
            this.examId = _data["examId"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            (<any>this).theoryFinishTime = _data["theoryFinishTime"] ? moment(_data["theoryFinishTime"].toString()) : <any>undefined;
            (<any>this).practiceStartTime = _data["practiceStartTime"] ? moment(_data["practiceStartTime"].toString()) : <any>undefined;
            this.isPassedTheory = _data["isPassedTheory"];
            (<any>this).passed = _data["passed"];
            (<any>this).finishTime = _data["finishTime"] ? moment(_data["finishTime"].toString()) : <any>undefined;
            this.totalTimeInMinutes = _data["totalTimeInMinutes"];
            (<any>this).theoreticalPassPercentage = _data["theoreticalPassPercentage"];
            (<any>this).totalPassPercentage = _data["totalPassPercentage"];
            (<any>this).correctTheoreticalAnswersPercentage = _data["correctTheoreticalAnswersPercentage"];
            this.theoreticalPartDuration = _data["theoreticalPartDuration"];
            this.practicalPartDuration = _data["practicalPartDuration"];
            (<any>this).isPassedPractice = _data["isPassedPractice"];
            (<any>this).correctPracticalAnswersPercentage = _data["correctPracticalAnswersPercentage"];
            if (Array.isArray(_data["factualTheoreticalQuestionAnswers"])) {
                (<any>this).factualTheoreticalQuestionAnswers = [] as any;
                for (let item of _data["factualTheoreticalQuestionAnswers"])
                    (<any>this).factualTheoreticalQuestionAnswers!.push(FactualTheoreticalQuestionAnswer.fromJS(item));
            }
            if (Array.isArray(_data["factualPracticalQuestionAnswers"])) {
                (<any>this).factualPracticalQuestionAnswers = [] as any;
                for (let item of _data["factualPracticalQuestionAnswers"])
                    (<any>this).factualPracticalQuestionAnswers!.push(FactualPracticalQuestionAnswer.fromJS(item));
            }
            this.manualCheck = _data["manualCheck"];
            if (Array.isArray(_data["theoreticalQuestions"])) {
                this.theoreticalQuestions = [] as any;
                for (let item of _data["theoreticalQuestions"])
                    this.theoreticalQuestions!.push(TheoreticalQuestion.fromJS(item));
            }
            if (Array.isArray(_data["practicalQuestions"])) {
                this.practicalQuestions = [] as any;
                for (let item of _data["practicalQuestions"])
                    this.practicalQuestions!.push(PracticalQuestion.fromJS(item));
            }
            (<any>this).criteriaForRate = _data["criteriaForRate"];
        }
    }

    static fromJS(data: any): ExamSessionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ExamSessionDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examApplicationId"] = this.examApplicationId;
        data["applicantId"] = this.applicantId;
        data["id"] = this.id;
        data["examId"] = this.examId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["theoryFinishTime"] = this.theoryFinishTime ? this.theoryFinishTime.toISOString() : <any>undefined;
        data["practiceStartTime"] = this.practiceStartTime ? this.practiceStartTime.toISOString() : <any>undefined;
        data["isPassedTheory"] = this.isPassedTheory;
        data["passed"] = this.passed;
        data["finishTime"] = this.finishTime ? this.finishTime.toISOString() : <any>undefined;
        data["totalTimeInMinutes"] = this.totalTimeInMinutes;
        data["theoreticalPassPercentage"] = this.theoreticalPassPercentage;
        data["totalPassPercentage"] = this.totalPassPercentage;
        data["correctTheoreticalAnswersPercentage"] = this.correctTheoreticalAnswersPercentage;
        data["theoreticalPartDuration"] = this.theoreticalPartDuration;
        data["practicalPartDuration"] = this.practicalPartDuration;
        data["isPassedPractice"] = this.isPassedPractice;
        data["correctPracticalAnswersPercentage"] = this.correctPracticalAnswersPercentage;
        if (Array.isArray(this.factualTheoreticalQuestionAnswers)) {
            data["factualTheoreticalQuestionAnswers"] = [];
            for (let item of this.factualTheoreticalQuestionAnswers)
                data["factualTheoreticalQuestionAnswers"].push(item.toJSON());
        }
        if (Array.isArray(this.factualPracticalQuestionAnswers)) {
            data["factualPracticalQuestionAnswers"] = [];
            for (let item of this.factualPracticalQuestionAnswers)
                data["factualPracticalQuestionAnswers"].push(item.toJSON());
        }
        data["manualCheck"] = this.manualCheck;
        if (Array.isArray(this.theoreticalQuestions)) {
            data["theoreticalQuestions"] = [];
            for (let item of this.theoreticalQuestions)
                data["theoreticalQuestions"].push(item.toJSON());
        }
        if (Array.isArray(this.practicalQuestions)) {
            data["practicalQuestions"] = [];
            for (let item of this.practicalQuestions)
                data["practicalQuestions"].push(item.toJSON());
        }
        data["criteriaForRate"] = this.criteriaForRate;
        return data; 
    }
}

export interface IExamSessionDetails {
    examApplicationId: string;
    applicantId: string;
    id: string;
    examId: string;
    startTime: moment.Moment;
    theoryFinishTime?: moment.Moment | undefined;
    practiceStartTime?: moment.Moment | undefined;
    isPassedTheory: boolean;
    passed?: boolean | undefined;
    finishTime?: moment.Moment | undefined;
    totalTimeInMinutes: number;
    theoreticalPassPercentage: number;
    totalPassPercentage: number;
    correctTheoreticalAnswersPercentage: number;
    theoreticalPartDuration: number;
    practicalPartDuration: number;
    isPassedPractice?: boolean | undefined;
    correctPracticalAnswersPercentage: number;
    factualTheoreticalQuestionAnswers: FactualTheoreticalQuestionAnswer[];
    factualPracticalQuestionAnswers: FactualPracticalQuestionAnswer[];
    manualCheck: boolean;
    theoreticalQuestions: TheoreticalQuestion[];
    practicalQuestions?: PracticalQuestion[] | undefined;
    criteriaForRate?: string | undefined;
}

export enum ExamSessionReadyStatuses {
    WaitingForStart = "waitingForStart",
    ExamIsPassing = "examIsPassing",
    TheoreticalExamIsPassingAndSessionStarted = "theoreticalExamIsPassingAndSessionStarted",
    ExamSessionTimeout = "examSessionTimeout",
    PracticalExamIsPassingAndSessionStarted = "practicalExamIsPassingAndSessionStarted",
    ExamFinished = "examFinished",
    SessionFinished = "sessionFinished",
}

export enum ExamSessionStatus {
    Active = "active",
    Completed = "completed",
}

export enum ExamStatus {
    AwaitingExpertConfirmation = "awaitingExpertConfirmation",
    IsApplying = "isApplying",
    ApplyingFinished = "applyingFinished",
    Canceled = "canceled",
    IsPassing = "isPassing",
    Finishing = "finishing",
    Finished = "finished",
    FinalizedResults = "finalizedResults",
    NokProtocolSigned = "nokProtocolSigned",
    AkProtocolSigned = "akProtocolSigned",
    SovietProtocolSignedByMembers = "sovietProtocolSignedByMembers",
    SovietProtocolSignedByChairman = "sovietProtocolSignedByChairman",
}

export enum ExamType {
    Intramural = "intramural",
    Recertification = "recertification",
    Online = "online",
}

export class ExamWithPayment implements IExamWithPayment {
    id!: string;
    date!: moment.Moment;
    qualificationId!: string;
    examinationCenterId!: string;
    qualificationTitle!: string;
    qualificationLevel!: string;
    occupationalStandardTitle!: string;
    qualificationEvaluationCenterName!: string;
    examinationCenterName!: string;
    address!: string;
    city!: string;
    status!: ExamStatus;
    statusChangeTime!: moment.Moment;
    /** Продолжительность экзамена в минутах */
    duration!: number;
    price!: number;
    /** Переаттестация */
    recertification!: boolean;
    type!: ExamType;
    qualificationEvaluationCenterId!: string;
    numberOfApplicants!: number;
    protocolNumber?: number | undefined;
    totalAmount!: number;
    paid!: boolean;
    accountNumber?: string | undefined;
    accountDate?: moment.Moment | undefined;
    amountDescription!: string;

    constructor(data?: IExamWithPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.qualificationId = _data["qualificationId"];
            this.examinationCenterId = _data["examinationCenterId"];
            this.qualificationTitle = _data["qualificationTitle"];
            this.qualificationLevel = _data["qualificationLevel"];
            this.occupationalStandardTitle = _data["occupationalStandardTitle"];
            this.qualificationEvaluationCenterName = _data["qualificationEvaluationCenterName"];
            this.examinationCenterName = _data["examinationCenterName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.status = _data["status"];
            this.statusChangeTime = _data["statusChangeTime"] ? moment(_data["statusChangeTime"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.price = _data["price"];
            this.recertification = _data["recertification"];
            this.type = _data["type"];
            this.qualificationEvaluationCenterId = _data["qualificationEvaluationCenterId"];
            this.numberOfApplicants = _data["numberOfApplicants"];
            this.protocolNumber = _data["protocolNumber"];
            this.totalAmount = _data["totalAmount"];
            this.paid = _data["paid"];
            this.accountNumber = _data["accountNumber"];
            this.accountDate = _data["accountDate"] ? moment(_data["accountDate"].toString()) : <any>undefined;
            this.amountDescription = _data["amountDescription"];
        }
    }

    static fromJS(data: any): ExamWithPayment {
        data = typeof data === 'object' ? data : {};
        let result = new ExamWithPayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["qualificationId"] = this.qualificationId;
        data["examinationCenterId"] = this.examinationCenterId;
        data["qualificationTitle"] = this.qualificationTitle;
        data["qualificationLevel"] = this.qualificationLevel;
        data["occupationalStandardTitle"] = this.occupationalStandardTitle;
        data["qualificationEvaluationCenterName"] = this.qualificationEvaluationCenterName;
        data["examinationCenterName"] = this.examinationCenterName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["status"] = this.status;
        data["statusChangeTime"] = this.statusChangeTime ? this.statusChangeTime.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["price"] = this.price;
        data["recertification"] = this.recertification;
        data["type"] = this.type;
        data["qualificationEvaluationCenterId"] = this.qualificationEvaluationCenterId;
        data["numberOfApplicants"] = this.numberOfApplicants;
        data["protocolNumber"] = this.protocolNumber;
        data["totalAmount"] = this.totalAmount;
        data["paid"] = this.paid;
        data["accountNumber"] = this.accountNumber;
        data["accountDate"] = this.accountDate ? this.accountDate.toISOString() : <any>undefined;
        data["amountDescription"] = this.amountDescription;
        return data; 
    }
}

export interface IExamWithPayment {
    id: string;
    date: moment.Moment;
    qualificationId: string;
    examinationCenterId: string;
    qualificationTitle: string;
    qualificationLevel: string;
    occupationalStandardTitle: string;
    qualificationEvaluationCenterName: string;
    examinationCenterName: string;
    address: string;
    city: string;
    status: ExamStatus;
    statusChangeTime: moment.Moment;
    /** Продолжительность экзамена в минутах */
    duration: number;
    price: number;
    /** Переаттестация */
    recertification: boolean;
    type: ExamType;
    qualificationEvaluationCenterId: string;
    numberOfApplicants: number;
    protocolNumber?: number | undefined;
    totalAmount: number;
    paid: boolean;
    accountNumber?: string | undefined;
    accountDate?: moment.Moment | undefined;
    amountDescription: string;
}

export class ExamWithPaymentDetails implements IExamWithPaymentDetails {
    id!: string;
    date!: moment.Moment;
    qualificationId!: string;
    examinationCenterId!: string;
    qualificationTitle!: string;
    qualificationLevel!: string;
    occupationalStandardTitle!: string;
    qualificationEvaluationCenterName!: string;
    examinationCenterName!: string;
    address!: string;
    city!: string;
    status!: ExamStatus;
    statusChangeTime!: moment.Moment;
    /** Продолжительность экзамена в минутах */
    duration!: number;
    price!: number;
    /** Переаттестация */
    recertification!: boolean;
    type!: ExamType;
    qualificationEvaluationCenterId!: string;
    numberOfApplicants!: number;
    protocolNumber?: number | undefined;
    /** Список экспертов экзаменационной комиссии / подписантов протокола НОК */
    experts!: ExamExpert[];
    /** Список подписантов протокола АК */
    akExperts!: ExamExpert[];
    /** Список подписантов протокола совета */
    sovietExperts!: ExamExpert[];
    actualStartTime?: moment.Moment | undefined;
    actualFinishTime?: moment.Moment | undefined;
    manualCheck!: boolean;
    examLogs!: ExamLog[];
    nokProtocolUrl?: string | undefined;
    akProtocolUrl?: string | undefined;
    sovietProtocolUrl?: string | undefined;
    rules?: string | undefined;
    theoreticalQuestionsCount!: number;
    theoreticalPartDuration!: number;
    practicalQuestionsCount!: number;
    practicalPartDuration!: number;
    protocolDate?: moment.Moment | undefined;
    practiceDefense!: boolean;
    /** Количество мест */
    applicationsLimit?: number | undefined;
    eventsState?: { [key: string]: number; } | undefined;
    totalAmount!: number;
    paid!: boolean;
    numberOfExperts!: number;
    amountDescription!: string;
    accountNumber?: string | undefined;
    accountDate?: moment.Moment | undefined;
    aktDocUrl?: string | undefined;
    aktExtraDocUrl?: string | undefined;
    invoiceForPaymentUrl?: string | undefined;

    constructor(data?: IExamWithPaymentDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.experts = [];
            this.akExperts = [];
            this.sovietExperts = [];
            this.examLogs = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.qualificationId = _data["qualificationId"];
            this.examinationCenterId = _data["examinationCenterId"];
            this.qualificationTitle = _data["qualificationTitle"];
            this.qualificationLevel = _data["qualificationLevel"];
            this.occupationalStandardTitle = _data["occupationalStandardTitle"];
            this.qualificationEvaluationCenterName = _data["qualificationEvaluationCenterName"];
            this.examinationCenterName = _data["examinationCenterName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.status = _data["status"];
            this.statusChangeTime = _data["statusChangeTime"] ? moment(_data["statusChangeTime"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.price = _data["price"];
            this.recertification = _data["recertification"];
            this.type = _data["type"];
            this.qualificationEvaluationCenterId = _data["qualificationEvaluationCenterId"];
            this.numberOfApplicants = _data["numberOfApplicants"];
            this.protocolNumber = _data["protocolNumber"];
            if (Array.isArray(_data["experts"])) {
                this.experts = [] as any;
                for (let item of _data["experts"])
                    this.experts!.push(ExamExpert.fromJS(item));
            }
            if (Array.isArray(_data["akExperts"])) {
                this.akExperts = [] as any;
                for (let item of _data["akExperts"])
                    this.akExperts!.push(ExamExpert.fromJS(item));
            }
            if (Array.isArray(_data["sovietExperts"])) {
                this.sovietExperts = [] as any;
                for (let item of _data["sovietExperts"])
                    this.sovietExperts!.push(ExamExpert.fromJS(item));
            }
            this.actualStartTime = _data["actualStartTime"] ? moment(_data["actualStartTime"].toString()) : <any>undefined;
            this.actualFinishTime = _data["actualFinishTime"] ? moment(_data["actualFinishTime"].toString()) : <any>undefined;
            this.manualCheck = _data["manualCheck"];
            if (Array.isArray(_data["examLogs"])) {
                this.examLogs = [] as any;
                for (let item of _data["examLogs"])
                    this.examLogs!.push(ExamLog.fromJS(item));
            }
            this.nokProtocolUrl = _data["nokProtocolUrl"];
            this.akProtocolUrl = _data["akProtocolUrl"];
            this.sovietProtocolUrl = _data["sovietProtocolUrl"];
            this.rules = _data["rules"];
            this.theoreticalQuestionsCount = _data["theoreticalQuestionsCount"];
            this.theoreticalPartDuration = _data["theoreticalPartDuration"];
            this.practicalQuestionsCount = _data["practicalQuestionsCount"];
            this.practicalPartDuration = _data["practicalPartDuration"];
            this.protocolDate = _data["protocolDate"] ? moment(_data["protocolDate"].toString()) : <any>undefined;
            this.practiceDefense = _data["practiceDefense"];
            this.applicationsLimit = _data["applicationsLimit"];
            if (_data["eventsState"]) {
                this.eventsState = {} as any;
                for (let key in _data["eventsState"]) {
                    if (_data["eventsState"].hasOwnProperty(key))
                        (<any>this.eventsState)![key] = _data["eventsState"][key];
                }
            }
            this.totalAmount = _data["totalAmount"];
            this.paid = _data["paid"];
            this.numberOfExperts = _data["numberOfExperts"];
            this.amountDescription = _data["amountDescription"];
            this.accountNumber = _data["accountNumber"];
            this.accountDate = _data["accountDate"] ? moment(_data["accountDate"].toString()) : <any>undefined;
            this.aktDocUrl = _data["aktDocUrl"];
            this.aktExtraDocUrl = _data["aktExtraDocUrl"];
            this.invoiceForPaymentUrl = _data["invoiceForPaymentUrl"];
        }
    }

    static fromJS(data: any): ExamWithPaymentDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ExamWithPaymentDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["qualificationId"] = this.qualificationId;
        data["examinationCenterId"] = this.examinationCenterId;
        data["qualificationTitle"] = this.qualificationTitle;
        data["qualificationLevel"] = this.qualificationLevel;
        data["occupationalStandardTitle"] = this.occupationalStandardTitle;
        data["qualificationEvaluationCenterName"] = this.qualificationEvaluationCenterName;
        data["examinationCenterName"] = this.examinationCenterName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["status"] = this.status;
        data["statusChangeTime"] = this.statusChangeTime ? this.statusChangeTime.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["price"] = this.price;
        data["recertification"] = this.recertification;
        data["type"] = this.type;
        data["qualificationEvaluationCenterId"] = this.qualificationEvaluationCenterId;
        data["numberOfApplicants"] = this.numberOfApplicants;
        data["protocolNumber"] = this.protocolNumber;
        if (Array.isArray(this.experts)) {
            data["experts"] = [];
            for (let item of this.experts)
                data["experts"].push(item.toJSON());
        }
        if (Array.isArray(this.akExperts)) {
            data["akExperts"] = [];
            for (let item of this.akExperts)
                data["akExperts"].push(item.toJSON());
        }
        if (Array.isArray(this.sovietExperts)) {
            data["sovietExperts"] = [];
            for (let item of this.sovietExperts)
                data["sovietExperts"].push(item.toJSON());
        }
        data["actualStartTime"] = this.actualStartTime ? this.actualStartTime.toISOString() : <any>undefined;
        data["actualFinishTime"] = this.actualFinishTime ? this.actualFinishTime.toISOString() : <any>undefined;
        data["manualCheck"] = this.manualCheck;
        if (Array.isArray(this.examLogs)) {
            data["examLogs"] = [];
            for (let item of this.examLogs)
                data["examLogs"].push(item.toJSON());
        }
        data["nokProtocolUrl"] = this.nokProtocolUrl;
        data["akProtocolUrl"] = this.akProtocolUrl;
        data["sovietProtocolUrl"] = this.sovietProtocolUrl;
        data["rules"] = this.rules;
        data["theoreticalQuestionsCount"] = this.theoreticalQuestionsCount;
        data["theoreticalPartDuration"] = this.theoreticalPartDuration;
        data["practicalQuestionsCount"] = this.practicalQuestionsCount;
        data["practicalPartDuration"] = this.practicalPartDuration;
        data["protocolDate"] = this.protocolDate ? this.protocolDate.toISOString() : <any>undefined;
        data["practiceDefense"] = this.practiceDefense;
        data["applicationsLimit"] = this.applicationsLimit;
        if (this.eventsState) {
            data["eventsState"] = {};
            for (let key in this.eventsState) {
                if (this.eventsState.hasOwnProperty(key))
                    (<any>data["eventsState"])[key] = this.eventsState[key];
            }
        }
        data["totalAmount"] = this.totalAmount;
        data["paid"] = this.paid;
        data["numberOfExperts"] = this.numberOfExperts;
        data["amountDescription"] = this.amountDescription;
        data["accountNumber"] = this.accountNumber;
        data["accountDate"] = this.accountDate ? this.accountDate.toISOString() : <any>undefined;
        data["aktDocUrl"] = this.aktDocUrl;
        data["aktExtraDocUrl"] = this.aktExtraDocUrl;
        data["invoiceForPaymentUrl"] = this.invoiceForPaymentUrl;
        return data; 
    }
}

export interface IExamWithPaymentDetails {
    id: string;
    date: moment.Moment;
    qualificationId: string;
    examinationCenterId: string;
    qualificationTitle: string;
    qualificationLevel: string;
    occupationalStandardTitle: string;
    qualificationEvaluationCenterName: string;
    examinationCenterName: string;
    address: string;
    city: string;
    status: ExamStatus;
    statusChangeTime: moment.Moment;
    /** Продолжительность экзамена в минутах */
    duration: number;
    price: number;
    /** Переаттестация */
    recertification: boolean;
    type: ExamType;
    qualificationEvaluationCenterId: string;
    numberOfApplicants: number;
    protocolNumber?: number | undefined;
    /** Список экспертов экзаменационной комиссии / подписантов протокола НОК */
    experts: ExamExpert[];
    /** Список подписантов протокола АК */
    akExperts: ExamExpert[];
    /** Список подписантов протокола совета */
    sovietExperts: ExamExpert[];
    actualStartTime?: moment.Moment | undefined;
    actualFinishTime?: moment.Moment | undefined;
    manualCheck: boolean;
    examLogs: ExamLog[];
    nokProtocolUrl?: string | undefined;
    akProtocolUrl?: string | undefined;
    sovietProtocolUrl?: string | undefined;
    rules?: string | undefined;
    theoreticalQuestionsCount: number;
    theoreticalPartDuration: number;
    practicalQuestionsCount: number;
    practicalPartDuration: number;
    protocolDate?: moment.Moment | undefined;
    practiceDefense: boolean;
    /** Количество мест */
    applicationsLimit?: number | undefined;
    eventsState?: { [key: string]: number; } | undefined;
    totalAmount: number;
    paid: boolean;
    numberOfExperts: number;
    amountDescription: string;
    accountNumber?: string | undefined;
    accountDate?: moment.Moment | undefined;
    aktDocUrl?: string | undefined;
    aktExtraDocUrl?: string | undefined;
    invoiceForPaymentUrl?: string | undefined;
}

export class ExamWithPaymentList implements IExamWithPaymentList {
    items!: ExamWithPayment[];
    page!: number;
    pageSize!: number;
    total!: number;
    unpaidAmount!: number;

    constructor(data?: IExamWithPaymentList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExamWithPayment.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.total = _data["total"];
            this.unpaidAmount = _data["unpaidAmount"];
        }
    }

    static fromJS(data: any): ExamWithPaymentList {
        data = typeof data === 'object' ? data : {};
        let result = new ExamWithPaymentList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["total"] = this.total;
        data["unpaidAmount"] = this.unpaidAmount;
        return data; 
    }
}

export interface IExamWithPaymentList {
    items: ExamWithPayment[];
    page: number;
    pageSize: number;
    total: number;
    unpaidAmount: number;
}

export class Expert implements IExpert {
    id!: string;
    regNumber!: string;
    firstName!: string;
    lastName!: string;
    middleName!: string;
    birthDate!: moment.Moment;
    sex!: Sex;
    phone!: string;
    email!: string;
    regionId!: number;
    region!: string;
    sovietMember!: boolean;
    akMember!: boolean;
    nokMember!: boolean;
    chairman!: boolean;
    employee?: boolean | undefined;
    emailConfirmed!: boolean;
    registrationCompleted!: boolean;
    /** Должность в случае члена совета */
    position?: string | undefined;
    applicantId?: string | undefined;

    constructor(data?: IExpert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regNumber = _data["regNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.sex = _data["sex"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.regionId = _data["regionId"];
            this.region = _data["region"];
            this.sovietMember = _data["sovietMember"];
            this.akMember = _data["akMember"];
            this.nokMember = _data["nokMember"];
            this.chairman = _data["chairman"];
            this.employee = _data["employee"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.registrationCompleted = _data["registrationCompleted"];
            this.position = _data["position"];
            this.applicantId = _data["applicantId"];
        }
    }

    static fromJS(data: any): Expert {
        data = typeof data === 'object' ? data : {};
        let result = new Expert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regNumber"] = this.regNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["sex"] = this.sex;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["regionId"] = this.regionId;
        data["region"] = this.region;
        data["sovietMember"] = this.sovietMember;
        data["akMember"] = this.akMember;
        data["nokMember"] = this.nokMember;
        data["chairman"] = this.chairman;
        data["employee"] = this.employee;
        data["emailConfirmed"] = this.emailConfirmed;
        data["registrationCompleted"] = this.registrationCompleted;
        data["position"] = this.position;
        data["applicantId"] = this.applicantId;
        return data; 
    }
}

export interface IExpert {
    id: string;
    regNumber: string;
    firstName: string;
    lastName: string;
    middleName: string;
    birthDate: moment.Moment;
    sex: Sex;
    phone: string;
    email: string;
    regionId: number;
    region: string;
    sovietMember: boolean;
    akMember: boolean;
    nokMember: boolean;
    chairman: boolean;
    employee?: boolean | undefined;
    emailConfirmed: boolean;
    registrationCompleted: boolean;
    /** Должность в случае члена совета */
    position?: string | undefined;
    applicantId?: string | undefined;
}

export class ExpertCertificate implements IExpertCertificate {
    readonly fileId!: string;
    readonly fileExtension!: string;
    readonly fileSize!: number;
    readonly fileUrl!: string;
    id!: string;
    /** Регистрационный номер */
    regNumber!: string;
    /** Дата выдачи */
    issueDate!: moment.Moment;
    /** Дата окончания действия */
    expireDate!: moment.Moment;

    constructor(data?: IExpertCertificate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).fileId = _data["fileId"];
            (<any>this).fileExtension = _data["fileExtension"];
            (<any>this).fileSize = _data["fileSize"];
            (<any>this).fileUrl = _data["fileUrl"];
            this.id = _data["id"];
            this.regNumber = _data["regNumber"];
            this.issueDate = _data["issueDate"] ? moment(_data["issueDate"].toString()) : <any>undefined;
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExpertCertificate {
        data = typeof data === 'object' ? data : {};
        let result = new ExpertCertificate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileExtension"] = this.fileExtension;
        data["fileSize"] = this.fileSize;
        data["fileUrl"] = this.fileUrl;
        data["id"] = this.id;
        data["regNumber"] = this.regNumber;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IExpertCertificate {
    fileId: string;
    fileExtension: string;
    fileSize: number;
    fileUrl: string;
    id: string;
    /** Регистрационный номер */
    regNumber: string;
    /** Дата выдачи */
    issueDate: moment.Moment;
    /** Дата окончания действия */
    expireDate: moment.Moment;
}

export class Experts implements IExperts {
    items!: Expert[];
    page!: number;
    pageSize!: number;
    total!: number;

    constructor(data?: IExperts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Expert.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): Experts {
        data = typeof data === 'object' ? data : {};
        let result = new Experts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["total"] = this.total;
        return data; 
    }
}

export interface IExperts {
    items: Expert[];
    page: number;
    pageSize: number;
    total: number;
}

export class FactualPracticalQuestionAnswer implements IFactualPracticalQuestionAnswer {
    readonly questionId!: string;
    readonly criteriaForRate?: string | undefined;
    type!: PracticalQuestionType;
    readonly correct?: boolean | undefined;
    essayAnswer?: EssayAnswer;
    openAnswerAnswer?: OpenAnswerAnswer;
    tabularAnswer?: CheckedTable[] | undefined;

    constructor(data?: IFactualPracticalQuestionAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).questionId = _data["questionId"];
            (<any>this).criteriaForRate = _data["criteriaForRate"];
            this.type = _data["type"];
            (<any>this).correct = _data["correct"];
            this.essayAnswer = _data["essayAnswer"] ? EssayAnswer.fromJS(_data["essayAnswer"]) : <any>undefined;
            this.openAnswerAnswer = _data["openAnswerAnswer"] ? OpenAnswerAnswer.fromJS(_data["openAnswerAnswer"]) : <any>undefined;
            if (Array.isArray(_data["tabularAnswer"])) {
                this.tabularAnswer = [] as any;
                for (let item of _data["tabularAnswer"])
                    this.tabularAnswer!.push(CheckedTable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FactualPracticalQuestionAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new FactualPracticalQuestionAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["criteriaForRate"] = this.criteriaForRate;
        data["type"] = this.type;
        data["correct"] = this.correct;
        data["essayAnswer"] = this.essayAnswer ? this.essayAnswer.toJSON() : <any>undefined;
        data["openAnswerAnswer"] = this.openAnswerAnswer ? this.openAnswerAnswer.toJSON() : <any>undefined;
        if (Array.isArray(this.tabularAnswer)) {
            data["tabularAnswer"] = [];
            for (let item of this.tabularAnswer)
                data["tabularAnswer"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IFactualPracticalQuestionAnswer {
    questionId: string;
    criteriaForRate?: string | undefined;
    type: PracticalQuestionType;
    correct?: boolean | undefined;
    essayAnswer?: EssayAnswer;
    openAnswerAnswer?: OpenAnswerAnswer;
    tabularAnswer?: CheckedTable[] | undefined;
}

export class FactualTheoreticalQuestionAnswer implements IFactualTheoreticalQuestionAnswer {
    readonly questionId!: string;
    readonly correct!: boolean;
    readonly correctAnswersNumbers!: AnswerPair[];
    readonly factualAnswersNumbers!: AnswerPair[];
    readonly correctAnswer?: string | undefined;
    readonly factualAnswer?: string | undefined;

    constructor(data?: IFactualTheoreticalQuestionAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.correctAnswersNumbers = [];
            this.factualAnswersNumbers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).questionId = _data["questionId"];
            (<any>this).correct = _data["correct"];
            if (Array.isArray(_data["correctAnswersNumbers"])) {
                (<any>this).correctAnswersNumbers = [] as any;
                for (let item of _data["correctAnswersNumbers"])
                    (<any>this).correctAnswersNumbers!.push(AnswerPair.fromJS(item));
            }
            if (Array.isArray(_data["factualAnswersNumbers"])) {
                (<any>this).factualAnswersNumbers = [] as any;
                for (let item of _data["factualAnswersNumbers"])
                    (<any>this).factualAnswersNumbers!.push(AnswerPair.fromJS(item));
            }
            (<any>this).correctAnswer = _data["correctAnswer"];
            (<any>this).factualAnswer = _data["factualAnswer"];
        }
    }

    static fromJS(data: any): FactualTheoreticalQuestionAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new FactualTheoreticalQuestionAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["correct"] = this.correct;
        if (Array.isArray(this.correctAnswersNumbers)) {
            data["correctAnswersNumbers"] = [];
            for (let item of this.correctAnswersNumbers)
                data["correctAnswersNumbers"].push(item.toJSON());
        }
        if (Array.isArray(this.factualAnswersNumbers)) {
            data["factualAnswersNumbers"] = [];
            for (let item of this.factualAnswersNumbers)
                data["factualAnswersNumbers"].push(item.toJSON());
        }
        data["correctAnswer"] = this.correctAnswer;
        data["factualAnswer"] = this.factualAnswer;
        return data; 
    }
}

export interface IFactualTheoreticalQuestionAnswer {
    questionId: string;
    correct: boolean;
    correctAnswersNumbers: AnswerPair[];
    factualAnswersNumbers: AnswerPair[];
    correctAnswer?: string | undefined;
    factualAnswer?: string | undefined;
}

/** Номер факса */
export class Fax implements IFax {
    /** Основной номер */
    number?: string | undefined;
    /** Добавочный */
    internal?: string | undefined;

    constructor(data?: IFax) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.internal = _data["internal"];
        }
    }

    static fromJS(data: any): Fax {
        data = typeof data === 'object' ? data : {};
        let result = new Fax();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["internal"] = this.internal;
        return data; 
    }
}

/** Номер факса */
export interface IFax {
    /** Основной номер */
    number?: string | undefined;
    /** Добавочный */
    internal?: string | undefined;
}

export enum FilteredExamStatus {
    AwaitingExpertConfirmation = "awaitingExpertConfirmation",
    IsApplying = "isApplying",
    ApplyingFinished = "applyingFinished",
    IsPassing = "isPassing",
    Finished = "finished",
    FinalizedResults = "finalizedResults",
    NokProtocolSigned = "nokProtocolSigned",
    AkProtocolSigned = "akProtocolSigned",
    Processed = "processed",
    Canceled = "canceled",
}

export enum IdentityDocType {
    Passport = "passport",
    Other = "other",
}

export class LoginEcUser implements ILoginEcUser {
    captcha?: string | undefined;
    email!: string;
    password!: string;

    constructor(data?: ILoginEcUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginEcUser {
        data = typeof data === 'object' ? data : {};
        let result = new LoginEcUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["email"] = this.email;
        data["password"] = this.password;
        return data; 
    }
}

export interface ILoginEcUser {
    captcha?: string | undefined;
    email: string;
    password: string;
}

export class OpenAnswerAnswer implements IOpenAnswerAnswer {
    correct!: string;
    factual?: string | undefined;

    constructor(data?: IOpenAnswerAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.correct = _data["correct"];
            this.factual = _data["factual"];
        }
    }

    static fromJS(data: any): OpenAnswerAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new OpenAnswerAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["correct"] = this.correct;
        data["factual"] = this.factual;
        return data; 
    }
}

export interface IOpenAnswerAnswer {
    correct: string;
    factual?: string | undefined;
}

/** Номер телефона */
export class Phone implements IPhone {
    /** Основной номер */
    number?: string | undefined;
    /** Добавочный */
    internal?: string | undefined;

    constructor(data?: IPhone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.internal = _data["internal"];
        }
    }

    static fromJS(data: any): Phone {
        data = typeof data === 'object' ? data : {};
        let result = new Phone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["internal"] = this.internal;
        return data; 
    }
}

/** Номер телефона */
export interface IPhone {
    /** Основной номер */
    number?: string | undefined;
    /** Добавочный */
    internal?: string | undefined;
}

export class PracticalQuestion implements IPracticalQuestion {
    /** Id вопроса */
    id!: string;
    /** Текст вопроса, в виде HTML */
    text!: string;
    type!: PracticalQuestionType;
    /** Таблицы для табличного вопроса */
    tabularQuestionTables?: Table[] | undefined;

    constructor(data?: IPracticalQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.type = _data["type"];
            if (Array.isArray(_data["tabularQuestionTables"])) {
                this.tabularQuestionTables = [] as any;
                for (let item of _data["tabularQuestionTables"])
                    this.tabularQuestionTables!.push(Table.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PracticalQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new PracticalQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["type"] = this.type;
        if (Array.isArray(this.tabularQuestionTables)) {
            data["tabularQuestionTables"] = [];
            for (let item of this.tabularQuestionTables)
                data["tabularQuestionTables"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPracticalQuestion {
    /** Id вопроса */
    id: string;
    /** Текст вопроса, в виде HTML */
    text: string;
    type: PracticalQuestionType;
    /** Таблицы для табличного вопроса */
    tabularQuestionTables?: Table[] | undefined;
}

export enum PracticalQuestionType {
    OpenAnswer = "openAnswer",
    Essay = "essay",
    ManualCheckTabular = "manualCheckTabular",
    AutoCheckTabular = "autoCheckTabular",
    Offline = "offline",
}

export class QecCertificate implements IQecCertificate {
    readonly fileId!: string;
    readonly fileExtension!: string;
    readonly fileSize!: number;
    readonly fileUrl!: string;
    id!: string;
    /** Регистрационный номер */
    regNumber!: string;
    /** Дата выдачи */
    issueDate!: moment.Moment;
    /** Дата окончания действия */
    expireDate!: moment.Moment;

    constructor(data?: IQecCertificate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).fileId = _data["fileId"];
            (<any>this).fileExtension = _data["fileExtension"];
            (<any>this).fileSize = _data["fileSize"];
            (<any>this).fileUrl = _data["fileUrl"];
            this.id = _data["id"];
            this.regNumber = _data["regNumber"];
            this.issueDate = _data["issueDate"] ? moment(_data["issueDate"].toString()) : <any>undefined;
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): QecCertificate {
        data = typeof data === 'object' ? data : {};
        let result = new QecCertificate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileExtension"] = this.fileExtension;
        data["fileSize"] = this.fileSize;
        data["fileUrl"] = this.fileUrl;
        data["id"] = this.id;
        data["regNumber"] = this.regNumber;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IQecCertificate {
    fileId: string;
    fileExtension: string;
    fileSize: number;
    fileUrl: string;
    id: string;
    /** Регистрационный номер */
    regNumber: string;
    /** Дата выдачи */
    issueDate: moment.Moment;
    /** Дата окончания действия */
    expireDate: moment.Moment;
}

export class QecQualification implements IQecQualification {
    id!: string;
    title!: string;
    level!: string;
    regNumber!: string;
    occupationalStandardId!: string;
    occupationalStandardTitle!: string;
    readyToUse!: boolean;
    assigned!: boolean;
    price!: number;
    allowRecertification!: boolean;
    recertificationPrice?: number | undefined;
    /** Разрешены онлайн экзамены */
    allowOnline!: boolean;

    constructor(data?: IQecQualification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.level = _data["level"];
            this.regNumber = _data["regNumber"];
            this.occupationalStandardId = _data["occupationalStandardId"];
            this.occupationalStandardTitle = _data["occupationalStandardTitle"];
            this.readyToUse = _data["readyToUse"];
            this.assigned = _data["assigned"];
            this.price = _data["price"];
            this.allowRecertification = _data["allowRecertification"];
            this.recertificationPrice = _data["recertificationPrice"];
            this.allowOnline = _data["allowOnline"];
        }
    }

    static fromJS(data: any): QecQualification {
        data = typeof data === 'object' ? data : {};
        let result = new QecQualification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["level"] = this.level;
        data["regNumber"] = this.regNumber;
        data["occupationalStandardId"] = this.occupationalStandardId;
        data["occupationalStandardTitle"] = this.occupationalStandardTitle;
        data["readyToUse"] = this.readyToUse;
        data["assigned"] = this.assigned;
        data["price"] = this.price;
        data["allowRecertification"] = this.allowRecertification;
        data["recertificationPrice"] = this.recertificationPrice;
        data["allowOnline"] = this.allowOnline;
        return data; 
    }
}

export interface IQecQualification {
    id: string;
    title: string;
    level: string;
    regNumber: string;
    occupationalStandardId: string;
    occupationalStandardTitle: string;
    readyToUse: boolean;
    assigned: boolean;
    price: number;
    allowRecertification: boolean;
    recertificationPrice?: number | undefined;
    /** Разрешены онлайн экзамены */
    allowOnline: boolean;
}

export class QualificationDetails implements IQualificationDetails {
    id!: string;
    title!: string;
    level!: string;
    regNumber!: string;
    occupationalStandardId!: string;
    occupationalStandardTitle!: string;
    readyToUse!: boolean;
    decree!: string;
    theoreticalPartDuration!: number;
    timeoutDuration!: number;
    practicalPartDuration!: number;
    theoreticalPassPercentage!: number;
    totalPassPercentage!: number;
    theoreticalQuestionsCount!: number;
    practicalTasksCount!: number;

    constructor(data?: IQualificationDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.level = _data["level"];
            this.regNumber = _data["regNumber"];
            this.occupationalStandardId = _data["occupationalStandardId"];
            this.occupationalStandardTitle = _data["occupationalStandardTitle"];
            this.readyToUse = _data["readyToUse"];
            this.decree = _data["decree"];
            this.theoreticalPartDuration = _data["theoreticalPartDuration"];
            this.timeoutDuration = _data["timeoutDuration"];
            this.practicalPartDuration = _data["practicalPartDuration"];
            this.theoreticalPassPercentage = _data["theoreticalPassPercentage"];
            this.totalPassPercentage = _data["totalPassPercentage"];
            this.theoreticalQuestionsCount = _data["theoreticalQuestionsCount"];
            this.practicalTasksCount = _data["practicalTasksCount"];
        }
    }

    static fromJS(data: any): QualificationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["level"] = this.level;
        data["regNumber"] = this.regNumber;
        data["occupationalStandardId"] = this.occupationalStandardId;
        data["occupationalStandardTitle"] = this.occupationalStandardTitle;
        data["readyToUse"] = this.readyToUse;
        data["decree"] = this.decree;
        data["theoreticalPartDuration"] = this.theoreticalPartDuration;
        data["timeoutDuration"] = this.timeoutDuration;
        data["practicalPartDuration"] = this.practicalPartDuration;
        data["theoreticalPassPercentage"] = this.theoreticalPassPercentage;
        data["totalPassPercentage"] = this.totalPassPercentage;
        data["theoreticalQuestionsCount"] = this.theoreticalQuestionsCount;
        data["practicalTasksCount"] = this.practicalTasksCount;
        return data; 
    }
}

export interface IQualificationDetails {
    id: string;
    title: string;
    level: string;
    regNumber: string;
    occupationalStandardId: string;
    occupationalStandardTitle: string;
    readyToUse: boolean;
    decree: string;
    theoreticalPartDuration: number;
    timeoutDuration: number;
    practicalPartDuration: number;
    theoreticalPassPercentage: number;
    totalPassPercentage: number;
    theoreticalQuestionsCount: number;
    practicalTasksCount: number;
}

export class QualificationDocumentTemplate implements IQualificationDocumentTemplate {
    /** Идентификатор шаблона */
    readonly id!: string;
    /** Порядок в списке */
    readonly order!: number;
    /** Вариант */
    readonly variant!: number;
    /** Описание */
    readonly description!: string;
    type!: DocumentType;

    constructor(data?: IQualificationDocumentTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).order = _data["order"];
            (<any>this).variant = _data["variant"];
            (<any>this).description = _data["description"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): QualificationDocumentTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationDocumentTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order"] = this.order;
        data["variant"] = this.variant;
        data["description"] = this.description;
        data["type"] = this.type;
        return data; 
    }
}

export interface IQualificationDocumentTemplate {
    /** Идентификатор шаблона */
    id: string;
    /** Порядок в списке */
    order: number;
    /** Вариант */
    variant: number;
    /** Описание */
    description: string;
    type: DocumentType;
}

export class QualificationDocumentTemplateGroup implements IQualificationDocumentTemplateGroup {
    title!: string;
    description!: string;
    order!: number;
    hasVariants!: boolean;
    templates!: QualificationDocumentTemplate[];

    constructor(data?: IQualificationDocumentTemplateGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.templates = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.order = _data["order"];
            this.hasVariants = _data["hasVariants"];
            if (Array.isArray(_data["templates"])) {
                this.templates = [] as any;
                for (let item of _data["templates"])
                    this.templates!.push(QualificationDocumentTemplate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QualificationDocumentTemplateGroup {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationDocumentTemplateGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["order"] = this.order;
        data["hasVariants"] = this.hasVariants;
        if (Array.isArray(this.templates)) {
            data["templates"] = [];
            for (let item of this.templates)
                data["templates"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IQualificationDocumentTemplateGroup {
    title: string;
    description: string;
    order: number;
    hasVariants: boolean;
    templates: QualificationDocumentTemplate[];
}

export class QualificationEvaluationCenter implements IQualificationEvaluationCenter {
    id!: string;
    regNumber!: string;
    name!: string;
    fullName!: string;
    /** Город */
    city!: string;
    /** Id региона */
    regionId!: number;
    host!: string;
    hasAcquiring!: boolean;
    agreementWithSpkfr!: string;
    agreementWithRs!: string;
    defaultExaminationCenterId!: string;

    constructor(data?: IQualificationEvaluationCenter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regNumber = _data["regNumber"];
            this.name = _data["name"];
            this.fullName = _data["fullName"];
            this.city = _data["city"];
            this.regionId = _data["regionId"];
            this.host = _data["host"];
            this.hasAcquiring = _data["hasAcquiring"];
            this.agreementWithSpkfr = _data["agreementWithSpkfr"];
            this.agreementWithRs = _data["agreementWithRs"];
            this.defaultExaminationCenterId = _data["defaultExaminationCenterId"];
        }
    }

    static fromJS(data: any): QualificationEvaluationCenter {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationEvaluationCenter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regNumber"] = this.regNumber;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["city"] = this.city;
        data["regionId"] = this.regionId;
        data["host"] = this.host;
        data["hasAcquiring"] = this.hasAcquiring;
        data["agreementWithSpkfr"] = this.agreementWithSpkfr;
        data["agreementWithRs"] = this.agreementWithRs;
        data["defaultExaminationCenterId"] = this.defaultExaminationCenterId;
        return data; 
    }
}

export interface IQualificationEvaluationCenter {
    id: string;
    regNumber: string;
    name: string;
    fullName: string;
    /** Город */
    city: string;
    /** Id региона */
    regionId: number;
    host: string;
    hasAcquiring: boolean;
    agreementWithSpkfr: string;
    agreementWithRs: string;
    defaultExaminationCenterId: string;
}

export class QualificationEvaluationCenterDetails implements IQualificationEvaluationCenterDetails {
    id!: string;
    regNumber!: string;
    name!: string;
    fullName!: string;
    /** Город */
    city!: string;
    /** Id региона */
    regionId!: number;
    host!: string;
    hasAcquiring!: boolean;
    agreementWithSpkfr!: string;
    agreementWithRs!: string;
    defaultExaminationCenterId!: string;
    /** Регистрационный номер основной экзаменационной площадки */
    examinationCenterRegNumber!: string;
    inn!: string;
    ogrn!: string;
    kpp!: string;
    directorsName!: string;
    legalAddress!: string;
    bankAccountNumber!: string;
    bankName!: string;
    bankBIK!: string;
    bankCorrespondentAccountNumber!: string;
    phones!: Phone[];
    faxes!: Fax[];
    emails!: string[];
    address!: string;
    website!: string;

    constructor(data?: IQualificationEvaluationCenterDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.phones = [];
            this.faxes = [];
            this.emails = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regNumber = _data["regNumber"];
            this.name = _data["name"];
            this.fullName = _data["fullName"];
            this.city = _data["city"];
            this.regionId = _data["regionId"];
            this.host = _data["host"];
            this.hasAcquiring = _data["hasAcquiring"];
            this.agreementWithSpkfr = _data["agreementWithSpkfr"];
            this.agreementWithRs = _data["agreementWithRs"];
            this.defaultExaminationCenterId = _data["defaultExaminationCenterId"];
            this.examinationCenterRegNumber = _data["examinationCenterRegNumber"];
            this.inn = _data["inn"];
            this.ogrn = _data["ogrn"];
            this.kpp = _data["kpp"];
            this.directorsName = _data["directorsName"];
            this.legalAddress = _data["legalAddress"];
            this.bankAccountNumber = _data["bankAccountNumber"];
            this.bankName = _data["bankName"];
            this.bankBIK = _data["bankBIK"];
            this.bankCorrespondentAccountNumber = _data["bankCorrespondentAccountNumber"];
            if (Array.isArray(_data["phones"])) {
                this.phones = [] as any;
                for (let item of _data["phones"])
                    this.phones!.push(Phone.fromJS(item));
            }
            if (Array.isArray(_data["faxes"])) {
                this.faxes = [] as any;
                for (let item of _data["faxes"])
                    this.faxes!.push(Fax.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
            this.address = _data["address"];
            this.website = _data["website"];
        }
    }

    static fromJS(data: any): QualificationEvaluationCenterDetails {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationEvaluationCenterDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regNumber"] = this.regNumber;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["city"] = this.city;
        data["regionId"] = this.regionId;
        data["host"] = this.host;
        data["hasAcquiring"] = this.hasAcquiring;
        data["agreementWithSpkfr"] = this.agreementWithSpkfr;
        data["agreementWithRs"] = this.agreementWithRs;
        data["defaultExaminationCenterId"] = this.defaultExaminationCenterId;
        data["examinationCenterRegNumber"] = this.examinationCenterRegNumber;
        data["inn"] = this.inn;
        data["ogrn"] = this.ogrn;
        data["kpp"] = this.kpp;
        data["directorsName"] = this.directorsName;
        data["legalAddress"] = this.legalAddress;
        data["bankAccountNumber"] = this.bankAccountNumber;
        data["bankName"] = this.bankName;
        data["bankBIK"] = this.bankBIK;
        data["bankCorrespondentAccountNumber"] = this.bankCorrespondentAccountNumber;
        if (Array.isArray(this.phones)) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        if (Array.isArray(this.faxes)) {
            data["faxes"] = [];
            for (let item of this.faxes)
                data["faxes"].push(item.toJSON());
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        data["address"] = this.address;
        data["website"] = this.website;
        return data; 
    }
}

export interface IQualificationEvaluationCenterDetails {
    id: string;
    regNumber: string;
    name: string;
    fullName: string;
    /** Город */
    city: string;
    /** Id региона */
    regionId: number;
    host: string;
    hasAcquiring: boolean;
    agreementWithSpkfr: string;
    agreementWithRs: string;
    defaultExaminationCenterId: string;
    /** Регистрационный номер основной экзаменационной площадки */
    examinationCenterRegNumber: string;
    inn: string;
    ogrn: string;
    kpp: string;
    directorsName: string;
    legalAddress: string;
    bankAccountNumber: string;
    bankName: string;
    bankBIK: string;
    bankCorrespondentAccountNumber: string;
    phones: Phone[];
    faxes: Fax[];
    emails: string[];
    address: string;
    website: string;
}

export class QualificationEvaluationCenters implements IQualificationEvaluationCenters {
    items!: QualificationEvaluationCenter[];
    page!: number;
    pageSize!: number;
    total!: number;

    constructor(data?: IQualificationEvaluationCenters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(QualificationEvaluationCenter.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): QualificationEvaluationCenters {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationEvaluationCenters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["total"] = this.total;
        return data; 
    }
}

export interface IQualificationEvaluationCenters {
    items: QualificationEvaluationCenter[];
    page: number;
    pageSize: number;
    total: number;
}

export class QualificationInfo implements IQualificationInfo {
    id!: string;
    title!: string;
    level!: string;
    regNumber!: string;
    occupationalStandardId!: string;
    occupationalStandardTitle!: string;
    readyToUse!: boolean;

    constructor(data?: IQualificationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.level = _data["level"];
            this.regNumber = _data["regNumber"];
            this.occupationalStandardId = _data["occupationalStandardId"];
            this.occupationalStandardTitle = _data["occupationalStandardTitle"];
            this.readyToUse = _data["readyToUse"];
        }
    }

    static fromJS(data: any): QualificationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["level"] = this.level;
        data["regNumber"] = this.regNumber;
        data["occupationalStandardId"] = this.occupationalStandardId;
        data["occupationalStandardTitle"] = this.occupationalStandardTitle;
        data["readyToUse"] = this.readyToUse;
        return data; 
    }
}

export interface IQualificationInfo {
    id: string;
    title: string;
    level: string;
    regNumber: string;
    occupationalStandardId: string;
    occupationalStandardTitle: string;
    readyToUse: boolean;
}

export class QualificationInfoList implements IQualificationInfoList {
    items!: QualificationInfo[];
    page!: number;
    pageSize!: number;
    total!: number;

    constructor(data?: IQualificationInfoList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(QualificationInfo.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): QualificationInfoList {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationInfoList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["total"] = this.total;
        return data; 
    }
}

export interface IQualificationInfoList {
    items: QualificationInfo[];
    page: number;
    pageSize: number;
    total: number;
}

export class Region implements IRegion {
    readonly id!: number;
    readonly name!: string;
    readonly timeZoneOffset!: number;

    constructor(data?: IRegion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).name = _data["name"];
            (<any>this).timeZoneOffset = _data["timeZoneOffset"];
        }
    }

    static fromJS(data: any): Region {
        data = typeof data === 'object' ? data : {};
        let result = new Region();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["timeZoneOffset"] = this.timeZoneOffset;
        return data; 
    }
}

export interface IRegion {
    id: number;
    name: string;
    timeZoneOffset: number;
}

export class ResetPassword implements IResetPassword {
    captcha?: string | undefined;
    /** Токен верификации */
    token!: string;
    /** Новый пароль */
    newPassword!: string;

    constructor(data?: IResetPassword) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.token = _data["token"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPassword {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPassword();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["token"] = this.token;
        data["newPassword"] = this.newPassword;
        return data; 
    }
}

export interface IResetPassword {
    captcha?: string | undefined;
    /** Токен верификации */
    token: string;
    /** Новый пароль */
    newPassword: string;
}

export class SendCodeToApproveApplication implements ISendCodeToApproveApplication {
    captcha?: string | undefined;

    constructor(data?: ISendCodeToApproveApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
        }
    }

    static fromJS(data: any): SendCodeToApproveApplication {
        data = typeof data === 'object' ? data : {};
        let result = new SendCodeToApproveApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        return data; 
    }
}

export interface ISendCodeToApproveApplication {
    captcha?: string | undefined;
}

export class SendConfirmationEmailAgain implements ISendConfirmationEmailAgain {
    captcha?: string | undefined;

    constructor(data?: ISendConfirmationEmailAgain) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
        }
    }

    static fromJS(data: any): SendConfirmationEmailAgain {
        data = typeof data === 'object' ? data : {};
        let result = new SendConfirmationEmailAgain();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        return data; 
    }
}

export interface ISendConfirmationEmailAgain {
    captcha?: string | undefined;
}

export class SendEmailForResetPassword implements ISendEmailForResetPassword {
    captcha?: string | undefined;
    /** Адрес электронной почты */
    email!: string;

    constructor(data?: ISendEmailForResetPassword) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SendEmailForResetPassword {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailForResetPassword();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["email"] = this.email;
        return data; 
    }
}

export interface ISendEmailForResetPassword {
    captcha?: string | undefined;
    /** Адрес электронной почты */
    email: string;
}

export class SetApplicantTempPassword implements ISetApplicantTempPassword {
    /** Новый временный пароль */
    newPassword!: string;

    constructor(data?: ISetApplicantTempPassword) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): SetApplicantTempPassword {
        data = typeof data === 'object' ? data : {};
        let result = new SetApplicantTempPassword();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        return data; 
    }
}

export interface ISetApplicantTempPassword {
    /** Новый временный пароль */
    newPassword: string;
}

export enum Sex {
    Male = "male",
    Female = "female",
}

export class SourceFile implements ISourceFile {
    readonly fileId!: string;
    readonly fileExtension!: string;
    readonly fileSize!: number;
    readonly fileUrl!: string;
    fileName?: string | undefined;

    constructor(data?: ISourceFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).fileId = _data["fileId"];
            (<any>this).fileExtension = _data["fileExtension"];
            (<any>this).fileSize = _data["fileSize"];
            (<any>this).fileUrl = _data["fileUrl"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): SourceFile {
        data = typeof data === 'object' ? data : {};
        let result = new SourceFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileExtension"] = this.fileExtension;
        data["fileSize"] = this.fileSize;
        data["fileUrl"] = this.fileUrl;
        data["fileName"] = this.fileName;
        return data; 
    }
}

export interface ISourceFile {
    fileId: string;
    fileExtension: string;
    fileSize: number;
    fileUrl: string;
    fileName?: string | undefined;
}

export class Table implements ITable {
    caption?: string | undefined;
    columns!: Column[];
    exactEquality!: boolean;
    forbidMoving!: boolean;
    initialRows!: string[][];
    answerRows?: string[][] | undefined;

    constructor(data?: ITable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.columns = [];
            this.initialRows = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caption = _data["caption"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(Column.fromJS(item));
            }
            this.exactEquality = _data["exactEquality"];
            this.forbidMoving = _data["forbidMoving"];
            if (Array.isArray(_data["initialRows"])) {
                this.initialRows = [] as any;
                for (let item of _data["initialRows"])
                    this.initialRows!.push(item);
            }
            if (Array.isArray(_data["answerRows"])) {
                this.answerRows = [] as any;
                for (let item of _data["answerRows"])
                    this.answerRows!.push(item);
            }
        }
    }

    static fromJS(data: any): Table {
        data = typeof data === 'object' ? data : {};
        let result = new Table();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caption"] = this.caption;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        data["exactEquality"] = this.exactEquality;
        data["forbidMoving"] = this.forbidMoving;
        if (Array.isArray(this.initialRows)) {
            data["initialRows"] = [];
            for (let item of this.initialRows)
                data["initialRows"].push(item);
        }
        if (Array.isArray(this.answerRows)) {
            data["answerRows"] = [];
            for (let item of this.answerRows)
                data["answerRows"].push(item);
        }
        return data; 
    }
}

export interface ITable {
    caption?: string | undefined;
    columns: Column[];
    exactEquality: boolean;
    forbidMoving: boolean;
    initialRows: string[][];
    answerRows?: string[][] | undefined;
}

export class TheoreticalAnswer implements ITheoreticalAnswer {
    number!: number;
    text!: string;

    constructor(data?: ITheoreticalAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): TheoreticalAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new TheoreticalAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["text"] = this.text;
        return data; 
    }
}

export interface ITheoreticalAnswer {
    number: number;
    text: string;
}

export class TheoreticalQuestion implements ITheoreticalQuestion {
    /** Id вопроса */
    id!: string;
    /** Текст вопроса, в виде HTML */
    text!: string;
    type!: TheoreticalQuestionType;
    /** Варианты ответов на вопрос */
    answers!: TheoreticalAnswer[];
    /** Варианты ответов для вопросов на сопоставление или с последовательностью */
    matchingAnswers?: TheoreticalAnswer[] | undefined;
    /** Заголовок над вариантами ответов, для вопросов на сопоставление или с последовательностью */
    answersHeader?: string | undefined;
    /** Заголовок над вариантами ответов, для вопросов на сопоставление или с последовательностью */
    matchingAnswersHeader?: string | undefined;

    constructor(data?: ITheoreticalQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.answers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.type = _data["type"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(TheoreticalAnswer.fromJS(item));
            }
            if (Array.isArray(_data["matchingAnswers"])) {
                this.matchingAnswers = [] as any;
                for (let item of _data["matchingAnswers"])
                    this.matchingAnswers!.push(TheoreticalAnswer.fromJS(item));
            }
            this.answersHeader = _data["answersHeader"];
            this.matchingAnswersHeader = _data["matchingAnswersHeader"];
        }
    }

    static fromJS(data: any): TheoreticalQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new TheoreticalQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["type"] = this.type;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        if (Array.isArray(this.matchingAnswers)) {
            data["matchingAnswers"] = [];
            for (let item of this.matchingAnswers)
                data["matchingAnswers"].push(item.toJSON());
        }
        data["answersHeader"] = this.answersHeader;
        data["matchingAnswersHeader"] = this.matchingAnswersHeader;
        return data; 
    }
}

export interface ITheoreticalQuestion {
    /** Id вопроса */
    id: string;
    /** Текст вопроса, в виде HTML */
    text: string;
    type: TheoreticalQuestionType;
    /** Варианты ответов на вопрос */
    answers: TheoreticalAnswer[];
    /** Варианты ответов для вопросов на сопоставление или с последовательностью */
    matchingAnswers?: TheoreticalAnswer[] | undefined;
    /** Заголовок над вариантами ответов, для вопросов на сопоставление или с последовательностью */
    answersHeader?: string | undefined;
    /** Заголовок над вариантами ответов, для вопросов на сопоставление или с последовательностью */
    matchingAnswersHeader?: string | undefined;
}

export enum TheoreticalQuestionType {
    MultipleChoice = "multipleChoice",
    Matching = "matching",
    OpenAnswer = "openAnswer",
    Ordering = "ordering",
}

export class UpdateExamApplicationByQec implements IUpdateExamApplicationByQec {
    /** Фамилия */
    lastName!: string;
    /** Имя */
    firstName!: string;
    /** Отчество */
    middleName!: string;
    sex!: Sex;
    /** Дата рождения, время должно быть 00ч. 00м. 00с. по UTC */
    birthDate!: moment.Moment;
    identityDocType!: IdentityDocType;
    passport?: ApplicantPassport;
    otherIdentity?: ApplicantOtherIdentity;

    constructor(data?: IUpdateExamApplicationByQec) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.sex = _data["sex"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.identityDocType = _data["identityDocType"];
            this.passport = _data["passport"] ? ApplicantPassport.fromJS(_data["passport"]) : <any>undefined;
            this.otherIdentity = _data["otherIdentity"] ? ApplicantOtherIdentity.fromJS(_data["otherIdentity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateExamApplicationByQec {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExamApplicationByQec();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["sex"] = this.sex;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["identityDocType"] = this.identityDocType;
        data["passport"] = this.passport ? this.passport.toJSON() : <any>undefined;
        data["otherIdentity"] = this.otherIdentity ? this.otherIdentity.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateExamApplicationByQec {
    /** Фамилия */
    lastName: string;
    /** Имя */
    firstName: string;
    /** Отчество */
    middleName: string;
    sex: Sex;
    /** Дата рождения, время должно быть 00ч. 00м. 00с. по UTC */
    birthDate: moment.Moment;
    identityDocType: IdentityDocType;
    passport?: ApplicantPassport;
    otherIdentity?: ApplicantOtherIdentity;
}

export class VerificationCodeSendingStatus implements IVerificationCodeSendingStatus {
    /** Были ли отправлен новый код или надо подождать */
    wasSent?: boolean;
    /** Время ожидания отправки нового кода */
    waitingSeconds?: number;

    constructor(data?: IVerificationCodeSendingStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wasSent = _data["wasSent"];
            this.waitingSeconds = _data["waitingSeconds"];
        }
    }

    static fromJS(data: any): VerificationCodeSendingStatus {
        data = typeof data === 'object' ? data : {};
        let result = new VerificationCodeSendingStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wasSent"] = this.wasSent;
        data["waitingSeconds"] = this.waitingSeconds;
        return data; 
    }
}

export interface IVerificationCodeSendingStatus {
    /** Были ли отправлен новый код или надо подождать */
    wasSent?: boolean;
    /** Время ожидания отправки нового кода */
    waitingSeconds?: number;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

export class ApiClient extends ApiClientBase {
    private http2: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl2: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(baseUrl, http);
        this.http2 = http ? http : <any>window;
        this.baseUrl2 = baseUrl ? baseUrl : "";
    }

    uploadExamApplicationDocumentFix(examApplicationId: string, templateId: string, file: File): Promise<ExamApplicationDetails> {
        let url_ = this.baseUrl2 + "/api/v1/creation-exam-applications/{examApplicationId}/documents/{templateId}";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter ‘file’ cannot be null.");
        else
            content_.append("file", file, file.name ? file.name : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http2.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadExamApplicationDocument(_response);
        });
    }
}